var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 519,
    viewBox: "0 0 415 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415 3.80071V48.419C415 50.5178 413.29 52.2176 411.183 52.2176V0C413.29 0 415 1.70195 415 3.80071Z",
    fill: "url(#paint0_radial_3145_298)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 49.9051V2.31286C407.997 1.037 406.955 0 405.671 0H403.155V21.3928C403.978 22.1386 404.676 22.9288 405.239 23.6457C405.625 24.1373 405.946 24.592 406.2 24.9756C406.351 25.2036 406.479 25.4059 406.581 25.5743C406.793 25.9209 406.793 26.2971 406.582 26.644C406.479 26.8121 406.351 27.0151 406.2 27.2441C405.946 27.6277 405.625 28.0824 405.239 28.574C404.893 29.0151 404.496 29.4855 404.048 29.9538C403.769 30.2467 403.471 30.5396 403.155 30.8248V52.2176H405.671C406.955 52.2176 407.997 51.1827 407.997 49.9051Z",
    fill: "url(#paint1_radial_3145_298)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 19.0723V0H399.572V19.0723C398.577 18.6678 397.492 18.423 396.33 18.423C395.168 18.423 394.086 18.6678 393.09 19.0723Z",
    fill: "url(#paint2_radial_3145_298)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 33.1475V52.2176H393.09V33.1475C394.086 33.5519 395.17 33.7967 396.33 33.7967C397.491 33.7967 398.575 33.5519 399.572 33.1475Z",
    fill: "url(#paint3_radial_3145_298)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 0H386.99C385.708 0 384.666 1.037 384.666 2.31286V49.9051C384.666 51.1827 385.708 52.2176 386.99 52.2176H389.507V30.8287C388.686 30.0828 387.987 29.2927 387.424 28.5779C386.808 27.7923 386.354 27.0956 386.079 26.6444C385.868 26.2971 385.868 25.9209 386.08 25.5739C386.354 25.1231 386.808 24.4267 387.424 23.6418C387.987 22.9249 388.686 22.1348 389.507 21.391V0Z",
    fill: "url(#paint4_radial_3145_298)",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 0V52.2197C379.369 52.2197 377.661 50.5178 377.661 48.4211V3.80071C377.661 1.70195 379.369 0 381.478 0Z",
    fill: "url(#paint5_radial_3145_298)",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 24.2817C399.133 21.8747 397.847 20.1323 396.33 20.1323C394.816 20.1323 393.532 21.8708 393.09 24.2723C392.984 24.8504 392.926 25.4672 392.926 26.1088C392.926 26.7507 392.984 27.3676 393.09 27.9474C393.532 30.3489 394.814 32.0853 396.33 32.0853C397.847 32.0853 399.133 30.3433 399.572 27.938C399.679 27.3617 399.735 26.7469 399.735 26.1088C399.735 25.4711 399.679 24.8581 399.572 24.2817Z",
    fill: "url(#paint6_radial_3145_298)",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 3.80071V48.419C352.058 50.5178 350.348 52.2176 348.241 52.2176V0C350.348 0 352.058 1.70195 352.058 3.80071Z",
    fill: "url(#paint7_radial_3145_298)",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 49.9051V2.31286C345.054 1.037 344.013 0 342.729 0H340.213V21.3928C341.036 22.1386 341.733 22.9288 342.297 23.6457C342.682 24.1373 343.004 24.592 343.257 24.9756C343.409 25.2036 343.536 25.4059 343.639 25.5743C343.851 25.9209 343.851 26.2971 343.639 26.644C343.537 26.8121 343.409 27.0151 343.257 27.2441C343.004 27.6277 342.682 28.0824 342.297 28.574C341.95 29.0151 341.553 29.4855 341.106 29.9538C340.827 30.2467 340.529 30.5396 340.213 30.8248V52.2176H342.729C344.013 52.2176 345.054 51.1827 345.054 49.9051Z",
    fill: "url(#paint8_radial_3145_298)",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 19.0723V0H336.63V19.0723C335.635 18.6678 334.55 18.423 333.388 18.423C332.226 18.423 331.144 18.6678 330.148 19.0723Z",
    fill: "url(#paint9_radial_3145_298)",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 33.1475V52.2176H330.148V33.1475C331.144 33.5519 332.228 33.7967 333.388 33.7967C334.548 33.7967 335.633 33.5519 336.63 33.1475Z",
    fill: "url(#paint10_radial_3145_298)",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 0H324.047C322.765 0 321.723 1.037 321.723 2.31286V49.9051C321.723 51.1827 322.765 52.2176 324.047 52.2176H326.565V30.8287C325.744 30.0828 325.045 29.2927 324.481 28.5779C323.865 27.7923 323.411 27.0956 323.137 26.6444C322.925 26.2971 322.926 25.9209 323.137 25.5739C323.412 25.1231 323.866 24.4267 324.481 23.6418C325.045 22.9249 325.744 22.1348 326.565 21.391V0Z",
    fill: "url(#paint11_radial_3145_298)",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 0V52.2197C316.427 52.2197 314.718 50.5178 314.718 48.4211V3.80071C314.718 1.70195 316.427 0 318.536 0Z",
    fill: "url(#paint12_radial_3145_298)",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 24.2817C336.19 21.8747 334.904 20.1323 333.388 20.1323C331.874 20.1323 330.59 21.8708 330.148 24.2723C330.041 24.8504 329.983 25.4672 329.983 26.1088C329.983 26.7507 330.041 27.3676 330.148 27.9474C330.59 30.3489 331.872 32.0853 333.388 32.0853C334.904 32.0853 336.19 30.3433 336.63 27.938C336.736 27.3617 336.793 26.7469 336.793 26.1088C336.793 25.4711 336.736 24.8581 336.63 24.2817Z",
    fill: "url(#paint13_radial_3145_298)",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 3.80071V48.419C289.111 50.5178 287.401 52.2176 285.294 52.2176V0C287.401 0 289.111 1.70195 289.111 3.80071Z",
    fill: "url(#paint14_radial_3145_298)",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 49.9051V2.31286C282.108 1.037 281.066 0 279.782 0H277.266V21.3928C278.089 22.1386 278.786 22.9288 279.35 23.6457C279.735 24.1373 280.057 24.592 280.31 24.9756C280.462 25.2036 280.59 25.4059 280.692 25.5743C280.904 25.9209 280.904 26.2971 280.692 26.644C280.59 26.8121 280.462 27.0151 280.31 27.2441C280.057 27.6277 279.735 28.0824 279.35 28.574C279.003 29.0151 278.606 29.4855 278.159 29.9538C277.88 30.2467 277.582 30.5396 277.266 30.8248V52.2176H279.782C281.066 52.2176 282.108 51.1827 282.108 49.9051Z",
    fill: "url(#paint15_radial_3145_298)",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 19.0723V0H273.683V19.0723C272.688 18.6678 271.603 18.423 270.441 18.423C269.279 18.423 268.197 18.6678 267.201 19.0723Z",
    fill: "url(#paint16_radial_3145_298)",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 33.1475V52.2176H267.201V33.1475C268.197 33.5519 269.281 33.7967 270.441 33.7967C271.601 33.7967 272.686 33.5519 273.683 33.1475Z",
    fill: "url(#paint17_radial_3145_298)",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 0H261.1C259.818 0 258.776 1.037 258.776 2.31286V49.9051C258.776 51.1827 259.818 52.2176 261.1 52.2176H263.618V30.8287C262.797 30.0828 262.098 29.2927 261.534 28.5779C260.919 27.7923 260.464 27.0956 260.19 26.6444C259.978 26.2971 259.979 25.9209 260.19 25.5739C260.465 25.1231 260.919 24.4267 261.534 23.6418C262.098 22.9249 262.797 22.1348 263.618 21.391V0Z",
    fill: "url(#paint18_radial_3145_298)",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 0V52.2197C253.48 52.2197 251.772 50.5178 251.772 48.4211V3.80071C251.772 1.70195 253.48 0 255.589 0Z",
    fill: "url(#paint19_radial_3145_298)",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 24.2817C273.244 21.8747 271.957 20.1323 270.441 20.1323C268.927 20.1323 267.643 21.8708 267.201 24.2723C267.094 24.8504 267.036 25.4672 267.036 26.1088C267.036 26.7507 267.094 27.3676 267.201 27.9474C267.643 30.3489 268.925 32.0853 270.441 32.0853C271.957 32.0853 273.244 30.3433 273.683 27.938C273.79 27.3617 273.846 26.7469 273.846 26.1088C273.846 25.4711 273.79 24.8581 273.683 24.2817Z",
    fill: "url(#paint20_radial_3145_298)",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 3.80071V48.419C226.173 50.5178 224.463 52.2176 222.356 52.2176V0C224.463 0 226.173 1.70195 226.173 3.80071Z",
    fill: "url(#paint21_radial_3145_298)",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 49.9051V2.31286C219.17 1.037 218.128 0 216.844 0H214.328V21.3928C215.151 22.1386 215.849 22.9288 216.412 23.6457C216.798 24.1373 217.119 24.592 217.373 24.9756C217.524 25.2036 217.652 25.4059 217.754 25.5743C217.966 25.9209 217.966 26.2971 217.755 26.644C217.652 26.8121 217.525 27.0151 217.373 27.2441C217.119 27.6277 216.798 28.0824 216.412 28.574C216.066 29.0151 215.669 29.4855 215.221 29.9538C214.942 30.2467 214.644 30.5396 214.328 30.8248V52.2176H216.844C218.128 52.2176 219.17 51.1827 219.17 49.9051Z",
    fill: "url(#paint22_radial_3145_298)",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 19.0723V0H210.746V19.0723C209.75 18.6678 208.665 18.423 207.503 18.423C206.342 18.423 205.259 18.6678 204.263 19.0723Z",
    fill: "url(#paint23_radial_3145_298)",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 33.1475V52.2176H204.263V33.1475C205.259 33.5519 206.343 33.7967 207.503 33.7967C208.664 33.7967 209.748 33.5519 210.746 33.1475Z",
    fill: "url(#paint24_radial_3145_298)",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 0H198.163C196.881 0 195.839 1.037 195.839 2.31286V49.9051C195.839 51.1827 196.881 52.2176 198.163 52.2176H200.68V30.8287C199.859 30.0828 199.16 29.2927 198.597 28.5779C197.981 27.7923 197.527 27.0956 197.252 26.6444C197.041 26.2971 197.041 25.9209 197.253 25.5739C197.528 25.1231 197.981 24.4267 198.597 23.6418C199.16 22.9249 199.859 22.1348 200.68 21.391V0Z",
    fill: "url(#paint25_radial_3145_298)",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 0V52.2197C190.542 52.2197 188.834 50.5178 188.834 48.4211V3.80071C188.834 1.70195 190.542 0 192.651 0Z",
    fill: "url(#paint26_radial_3145_298)",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 24.2817C210.306 21.8747 209.02 20.1323 207.503 20.1323C205.989 20.1323 204.705 21.8708 204.263 24.2723C204.157 24.8504 204.099 25.4672 204.099 26.1088C204.099 26.7507 204.157 27.3676 204.263 27.9474C204.705 30.3489 205.987 32.0853 207.503 32.0853C209.02 32.0853 210.306 30.3433 210.746 27.938C210.852 27.3617 210.908 26.7469 210.908 26.1088C210.908 25.4711 210.852 24.8581 210.746 24.2817Z",
    fill: "url(#paint27_radial_3145_298)",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 3.80071V48.419C163.226 50.5178 161.516 52.2176 159.409 52.2176V0C161.516 0 163.226 1.70195 163.226 3.80071Z",
    fill: "url(#paint28_radial_3145_298)",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 49.9051V2.31286C156.223 1.037 155.181 0 153.897 0H151.381V21.3928C152.204 22.1386 152.902 22.9288 153.465 23.6457C153.851 24.1373 154.172 24.592 154.426 24.9756C154.577 25.2036 154.705 25.4059 154.807 25.5743C155.019 25.9209 155.019 26.2971 154.808 26.644C154.705 26.8121 154.578 27.0151 154.426 27.2441C154.172 27.6277 153.851 28.0824 153.465 28.574C153.119 29.0151 152.722 29.4855 152.274 29.9538C151.995 30.2467 151.697 30.5396 151.381 30.8248V52.2176H153.897C155.181 52.2176 156.223 51.1827 156.223 49.9051Z",
    fill: "url(#paint29_radial_3145_298)",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 19.0723V0H147.799V19.0723C146.803 18.6678 145.718 18.423 144.556 18.423C143.395 18.423 142.312 18.6678 141.317 19.0723Z",
    fill: "url(#paint30_radial_3145_298)",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 33.1475V52.2176H141.317V33.1475C142.312 33.5519 143.396 33.7967 144.556 33.7967C145.717 33.7967 146.801 33.5519 147.799 33.1475Z",
    fill: "url(#paint31_radial_3145_298)",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 0H135.216C133.934 0 132.892 1.037 132.892 2.31286V49.9051C132.892 51.1827 133.934 52.2176 135.216 52.2176H137.733V30.8287C136.913 30.0828 136.213 29.2927 135.65 28.5779C135.034 27.7923 134.58 27.0956 134.305 26.6444C134.094 26.2971 134.094 25.9209 134.306 25.5739C134.581 25.1231 135.034 24.4267 135.65 23.6418C136.213 22.9249 136.913 22.1348 137.733 21.391V0Z",
    fill: "url(#paint32_radial_3145_298)",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 0V52.2197C127.595 52.2197 125.887 50.5178 125.887 48.4211V3.80071C125.887 1.70195 127.595 0 129.704 0Z",
    fill: "url(#paint33_radial_3145_298)",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 24.2817C147.359 21.8747 146.073 20.1323 144.556 20.1323C143.042 20.1323 141.758 21.8708 141.317 24.2723C141.21 24.8504 141.152 25.4672 141.152 26.1088C141.152 26.7507 141.21 27.3676 141.317 27.9474C141.758 30.3489 143.04 32.0853 144.556 32.0853C146.073 32.0853 147.359 30.3433 147.799 27.938C147.905 27.3617 147.961 26.7469 147.961 26.1088C147.961 25.4711 147.905 24.8581 147.799 24.2817Z",
    fill: "url(#paint34_radial_3145_298)",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 3.80071V48.419C100.284 50.5178 98.5738 52.2176 96.4667 52.2176V0C98.5738 0 100.284 1.70195 100.284 3.80071Z",
    fill: "url(#paint35_radial_3145_298)",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 49.9051V2.31286C93.2806 1.037 92.239 0 90.955 0H88.439V21.3928C89.2621 22.1386 89.9595 22.9288 90.523 23.6457C90.9084 24.1373 91.2299 24.592 91.4834 24.9756C91.6349 25.2036 91.7626 25.4059 91.8651 25.5743C92.0767 25.9209 92.077 26.2971 91.8654 26.644C91.7629 26.8121 91.6352 27.0151 91.4834 27.2441C91.2299 27.6277 90.9084 28.0824 90.523 28.574C90.1764 29.0151 89.7794 29.4855 89.332 29.9538C89.0529 30.2467 88.7549 30.5396 88.439 30.8248V52.2176H90.955C92.239 52.2176 93.2806 51.1827 93.2806 49.9051Z",
    fill: "url(#paint36_radial_3145_298)",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 19.0723V0H84.8563V19.0723C83.8608 18.6678 82.7762 18.423 81.6142 18.423C80.4522 18.423 79.3697 18.6678 78.3743 19.0723Z",
    fill: "url(#paint37_radial_3145_298)",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 33.1475V52.2176H78.3743V33.1475C79.3697 33.5519 80.454 33.7967 81.6142 33.7967C82.7744 33.7967 83.8587 33.5519 84.8563 33.1475Z",
    fill: "url(#paint38_radial_3145_298)",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 0H72.2735C70.9915 0 69.9496 1.037 69.9496 2.31286V49.9051C69.9496 51.1827 70.9915 52.2176 72.2735 52.2176H74.7912V30.8287C73.9702 30.0828 73.271 29.2927 72.7075 28.5779C72.0916 27.7923 71.6376 27.0956 71.3626 26.6444C71.1514 26.2971 71.1517 25.9209 71.3634 25.5739C71.6383 25.1231 72.0919 24.4267 72.7075 23.6418C73.271 22.9249 73.9702 22.1348 74.7912 21.391V0Z",
    fill: "url(#paint39_radial_3145_298)",
    fillOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 0V52.2197C64.6529 52.2197 62.9446 50.5178 62.9446 48.4211V3.80071C62.9446 1.70195 64.6529 0 66.7617 0Z",
    fill: "url(#paint40_radial_3145_298)",
    fillOpacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 24.2817C84.4166 21.8747 83.1305 20.1323 81.6142 20.1323C80.0997 20.1323 78.8157 21.8708 78.3743 24.2723C78.2676 24.8504 78.2095 25.4672 78.2095 26.1088C78.2095 26.7507 78.2676 27.3676 78.3743 27.9474C78.8157 30.3489 80.0979 32.0853 81.6142 32.0853C83.1305 32.0853 84.4166 30.3433 84.8563 27.938C84.9626 27.3617 85.019 26.7469 85.019 26.1088C85.019 25.4711 84.9626 24.8581 84.8563 24.2817Z",
    fill: "url(#paint41_radial_3145_298)",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 3.80071V48.419C37.3392 50.5178 35.6291 52.2176 33.5221 52.2176V0C35.6291 0 37.3392 1.70195 37.3392 3.80071Z",
    fill: "url(#paint42_radial_3145_298)",
    fillOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 49.9051V2.31286C30.336 1.037 29.2943 0 28.0103 0H25.4944V21.3928C26.3174 22.1386 27.0149 22.9288 27.5784 23.6457C27.9638 24.1373 28.2852 24.592 28.5388 24.9756C28.6902 25.2036 28.8179 25.4059 28.9204 25.5743C29.132 25.9209 29.1324 26.2971 28.9208 26.644C28.8183 26.8121 28.6906 27.0151 28.5388 27.2441C28.2852 27.6277 27.9638 28.0824 27.5784 28.574C27.2318 29.0151 26.8347 29.4855 26.3874 29.9538C26.1082 30.2467 25.8102 30.5396 25.4944 30.8248V52.2176H28.0103C29.2943 52.2176 30.336 51.1827 30.336 49.9051Z",
    fill: "url(#paint43_radial_3145_298)",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 19.0723V0H21.9116V19.0723C20.9162 18.6678 19.8315 18.423 18.6696 18.423C17.5076 18.423 16.4251 18.6678 15.4296 19.0723Z",
    fill: "url(#paint44_radial_3145_298)",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 33.1475V52.2176H15.4296V33.1475C16.4251 33.5519 17.5094 33.7967 18.6696 33.7967C19.8298 33.7967 20.9141 33.5519 21.9116 33.1475Z",
    fill: "url(#paint45_radial_3145_298)",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 0H9.32883C8.04691 0 7.00491 1.037 7.00491 2.31286V49.9051C7.00491 51.1827 8.04691 52.2176 9.32883 52.2176H11.8465V30.8287C11.0256 30.0828 10.3264 29.2927 9.76291 28.5779C9.14694 27.7923 8.6929 27.0956 8.418 26.6444C8.20673 26.2971 8.20712 25.9209 8.41873 25.5739C8.69366 25.1231 9.14731 24.4267 9.76291 23.6418C10.3264 22.9249 11.0256 22.1348 11.8465 21.391V0Z",
    fill: "url(#paint46_radial_3145_298)",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 0V52.2197C1.70831 52.2197 0 50.5178 0 48.4211V3.80071C0 1.70195 1.70831 0 3.81711 0Z",
    fill: "url(#paint47_radial_3145_298)",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 24.2817C21.472 21.8747 20.1859 20.1323 18.6696 20.1323C17.155 20.1323 15.871 21.8708 15.4296 24.2723C15.3229 24.8504 15.2649 25.4672 15.2649 26.1088C15.2649 26.7507 15.3229 27.3676 15.4296 27.9474C15.871 30.3489 17.1533 32.0853 18.6696 32.0853C20.1859 32.0853 21.472 30.3433 21.9116 27.938C22.0179 27.3617 22.0743 26.7469 22.0743 26.1088C22.0743 25.4711 22.0179 24.8581 21.9116 24.2817Z",
    fill: "url(#paint48_radial_3145_298)",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M415 81.5975V126.216C415 128.315 413.29 130.014 411.183 130.014V77.7968C413.29 77.7968 415 79.4987 415 81.5975Z",
    fill: "url(#paint49_radial_3145_298)",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 127.702V80.1096C407.997 78.8338 406.955 77.7968 405.671 77.7968H403.155V99.1895C403.978 99.9354 404.676 100.726 405.239 101.442C405.625 101.934 405.946 102.389 406.2 102.772C406.351 103 406.479 103.203 406.581 103.371C406.793 103.718 406.793 104.094 406.582 104.441C406.479 104.609 406.351 104.812 406.2 105.041C405.946 105.424 405.625 105.879 405.239 106.371C404.893 106.812 404.496 107.282 404.048 107.751C403.769 108.043 403.471 108.336 403.155 108.622V130.014H405.671C406.955 130.014 407.997 128.979 407.997 127.702Z",
    fill: "url(#paint50_radial_3145_298)",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 96.869V77.7968H399.572V96.869C398.577 96.4645 397.492 96.2198 396.33 96.2198C395.168 96.2198 394.086 96.4645 393.09 96.869Z",
    fill: "url(#paint51_radial_3145_298)",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 110.944V130.014H393.09V110.944C394.086 111.349 395.17 111.593 396.33 111.593C397.491 111.593 398.575 111.349 399.572 110.944Z",
    fill: "url(#paint52_radial_3145_298)",
    fillOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 77.7968H386.99C385.708 77.7968 384.666 78.8338 384.666 80.1096V127.702C384.666 128.979 385.708 130.014 386.99 130.014H389.507V108.625C388.686 107.88 387.987 107.089 387.424 106.375C386.808 105.589 386.354 104.892 386.079 104.441C385.868 104.094 385.868 103.718 386.08 103.371C386.354 102.92 386.808 102.223 387.424 101.439C387.987 100.722 388.686 99.9315 389.507 99.1878V77.7968Z",
    fill: "url(#paint53_radial_3145_298)",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 77.7968V130.016C379.369 130.016 377.661 128.315 377.661 126.218V81.5975C377.661 79.4987 379.369 77.7968 381.478 77.7968Z",
    fill: "url(#paint54_radial_3145_298)",
    fillOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 102.078C399.133 99.6714 397.847 97.929 396.33 97.929C394.816 97.929 393.532 99.6676 393.09 102.069C392.984 102.647 392.926 103.264 392.926 103.906C392.926 104.548 392.984 105.164 393.09 105.744C393.532 108.146 394.814 109.882 396.33 109.882C397.847 109.882 399.133 108.14 399.572 105.735C399.679 105.158 399.735 104.544 399.735 103.906C399.735 103.268 399.679 102.655 399.572 102.078Z",
    fill: "url(#paint55_radial_3145_298)",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 81.5975V126.216C352.058 128.315 350.348 130.014 348.241 130.014V77.7968C350.348 77.7968 352.058 79.4987 352.058 81.5975Z",
    fill: "url(#paint56_radial_3145_298)",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 127.702V80.1096C345.054 78.8338 344.013 77.7968 342.729 77.7968H340.213V99.1895C341.036 99.9354 341.733 100.726 342.297 101.442C342.682 101.934 343.004 102.389 343.257 102.772C343.409 103 343.536 103.203 343.639 103.371C343.851 103.718 343.851 104.094 343.639 104.441C343.537 104.609 343.409 104.812 343.257 105.041C343.004 105.424 342.682 105.879 342.297 106.371C341.95 106.812 341.553 107.282 341.106 107.751C340.827 108.043 340.529 108.336 340.213 108.622V130.014H342.729C344.013 130.014 345.054 128.979 345.054 127.702Z",
    fill: "url(#paint57_radial_3145_298)",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 96.869V77.7968H336.63V96.869C335.635 96.4645 334.55 96.2198 333.388 96.2198C332.226 96.2198 331.144 96.4645 330.148 96.869Z",
    fill: "url(#paint58_radial_3145_298)",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 110.944V130.014H330.148V110.944C331.144 111.349 332.228 111.593 333.388 111.593C334.548 111.593 335.633 111.349 336.63 110.944Z",
    fill: "url(#paint59_radial_3145_298)",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 77.7968H324.047C322.765 77.7968 321.723 78.8338 321.723 80.1096V127.702C321.723 128.979 322.765 130.014 324.047 130.014H326.565V108.625C325.744 107.88 325.045 107.089 324.481 106.375C323.865 105.589 323.411 104.892 323.137 104.441C322.925 104.094 322.926 103.718 323.137 103.371C323.412 102.92 323.866 102.223 324.481 101.439C325.045 100.722 325.744 99.9315 326.565 99.1878V77.7968Z",
    fill: "url(#paint60_radial_3145_298)",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 77.7968V130.016C316.427 130.016 314.718 128.315 314.718 126.218V81.5975C314.718 79.4987 316.427 77.7968 318.536 77.7968Z",
    fill: "url(#paint61_radial_3145_298)",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 102.078C336.19 99.6714 334.904 97.929 333.388 97.929C331.874 97.929 330.59 99.6676 330.148 102.069C330.041 102.647 329.983 103.264 329.983 103.906C329.983 104.548 330.041 105.164 330.148 105.744C330.59 108.146 331.872 109.882 333.388 109.882C334.904 109.882 336.19 108.14 336.63 105.735C336.736 105.158 336.793 104.544 336.793 103.906C336.793 103.268 336.736 102.655 336.63 102.078Z",
    fill: "url(#paint62_radial_3145_298)",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 81.5975V126.216C289.111 128.315 287.401 130.014 285.294 130.014V77.7968C287.401 77.7968 289.111 79.4987 289.111 81.5975Z",
    fill: "url(#paint63_radial_3145_298)",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 127.702V80.1096C282.108 78.8338 281.066 77.7968 279.782 77.7968H277.266V99.1895C278.089 99.9354 278.786 100.726 279.35 101.442C279.735 101.934 280.057 102.389 280.31 102.772C280.462 103 280.59 103.203 280.692 103.371C280.904 103.718 280.904 104.094 280.692 104.441C280.59 104.609 280.462 104.812 280.31 105.041C280.057 105.424 279.735 105.879 279.35 106.371C279.003 106.812 278.606 107.282 278.159 107.751C277.88 108.043 277.582 108.336 277.266 108.622V130.014H279.782C281.066 130.014 282.108 128.979 282.108 127.702Z",
    fill: "url(#paint64_radial_3145_298)",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 96.869V77.7968H273.683V96.869C272.688 96.4645 271.603 96.2198 270.441 96.2198C269.279 96.2198 268.197 96.4645 267.201 96.869Z",
    fill: "url(#paint65_radial_3145_298)",
    fillOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 110.944V130.014H267.201V110.944C268.197 111.349 269.281 111.593 270.441 111.593C271.601 111.593 272.686 111.349 273.683 110.944Z",
    fill: "url(#paint66_radial_3145_298)",
    fillOpacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 77.7968H261.1C259.818 77.7968 258.776 78.8338 258.776 80.1096V127.702C258.776 128.979 259.818 130.014 261.1 130.014H263.618V108.625C262.797 107.88 262.098 107.089 261.534 106.375C260.919 105.589 260.464 104.892 260.19 104.441C259.978 104.094 259.979 103.718 260.19 103.371C260.465 102.92 260.919 102.223 261.534 101.439C262.098 100.722 262.797 99.9315 263.618 99.1878V77.7968Z",
    fill: "url(#paint67_radial_3145_298)",
    fillOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 77.7968V130.016C253.48 130.016 251.772 128.315 251.772 126.218V81.5975C251.772 79.4987 253.48 77.7968 255.589 77.7968Z",
    fill: "url(#paint68_radial_3145_298)",
    fillOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 102.078C273.244 99.6714 271.957 97.929 270.441 97.929C268.927 97.929 267.643 99.6676 267.201 102.069C267.094 102.647 267.036 103.264 267.036 103.906C267.036 104.548 267.094 105.164 267.201 105.744C267.643 108.146 268.925 109.882 270.441 109.882C271.957 109.882 273.244 108.14 273.683 105.735C273.79 105.158 273.846 104.544 273.846 103.906C273.846 103.268 273.79 102.655 273.683 102.078Z",
    fill: "url(#paint69_radial_3145_298)",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 81.5975V126.216C226.173 128.315 224.463 130.014 222.356 130.014V77.7968C224.463 77.7968 226.173 79.4987 226.173 81.5975Z",
    fill: "url(#paint70_radial_3145_298)",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 127.702V80.1096C219.17 78.8338 218.128 77.7968 216.844 77.7968H214.328V99.1895C215.151 99.9354 215.849 100.726 216.412 101.442C216.798 101.934 217.119 102.389 217.373 102.772C217.524 103 217.652 103.203 217.754 103.371C217.966 103.718 217.966 104.094 217.755 104.441C217.652 104.609 217.525 104.812 217.373 105.041C217.119 105.424 216.798 105.879 216.412 106.371C216.066 106.812 215.669 107.282 215.221 107.751C214.942 108.043 214.644 108.336 214.328 108.622V130.014H216.844C218.128 130.014 219.17 128.979 219.17 127.702Z",
    fill: "url(#paint71_radial_3145_298)",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 96.869V77.7968H210.746V96.869C209.75 96.4645 208.665 96.2198 207.503 96.2198C206.342 96.2198 205.259 96.4645 204.263 96.869Z",
    fill: "url(#paint72_radial_3145_298)",
    fillOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 110.944V130.014H204.263V110.944C205.259 111.349 206.343 111.593 207.503 111.593C208.664 111.593 209.748 111.349 210.746 110.944Z",
    fill: "url(#paint73_radial_3145_298)",
    fillOpacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 77.7968H198.163C196.881 77.7968 195.839 78.8338 195.839 80.1096V127.702C195.839 128.979 196.881 130.014 198.163 130.014H200.68V108.625C199.859 107.88 199.16 107.089 198.597 106.375C197.981 105.589 197.527 104.892 197.252 104.441C197.041 104.094 197.041 103.718 197.253 103.371C197.528 102.92 197.981 102.223 198.597 101.439C199.16 100.722 199.859 99.9315 200.68 99.1878V77.7968Z",
    fill: "url(#paint74_radial_3145_298)",
    fillOpacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 77.7968V130.016C190.542 130.016 188.834 128.315 188.834 126.218V81.5975C188.834 79.4987 190.542 77.7968 192.651 77.7968Z",
    fill: "url(#paint75_radial_3145_298)",
    fillOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 102.078C210.306 99.6714 209.02 97.929 207.503 97.929C205.989 97.929 204.705 99.6676 204.263 102.069C204.157 102.647 204.099 103.264 204.099 103.906C204.099 104.548 204.157 105.164 204.263 105.744C204.705 108.146 205.987 109.882 207.503 109.882C209.02 109.882 210.306 108.14 210.746 105.735C210.852 105.158 210.908 104.544 210.908 103.906C210.908 103.268 210.852 102.655 210.746 102.078Z",
    fill: "url(#paint76_radial_3145_298)",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 81.5975V126.216C163.226 128.315 161.516 130.014 159.409 130.014V77.7968C161.516 77.7968 163.226 79.4987 163.226 81.5975Z",
    fill: "url(#paint77_radial_3145_298)",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 127.702V80.1096C156.223 78.8338 155.181 77.7968 153.897 77.7968H151.381V99.1895C152.204 99.9354 152.902 100.726 153.465 101.442C153.851 101.934 154.172 102.389 154.426 102.772C154.577 103 154.705 103.203 154.807 103.371C155.019 103.718 155.019 104.094 154.808 104.441C154.705 104.609 154.578 104.812 154.426 105.041C154.172 105.424 153.851 105.879 153.465 106.371C153.119 106.812 152.722 107.282 152.274 107.751C151.995 108.043 151.697 108.336 151.381 108.622V130.014H153.897C155.181 130.014 156.223 128.979 156.223 127.702Z",
    fill: "url(#paint78_radial_3145_298)",
    fillOpacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 96.869V77.7968H147.799V96.869C146.803 96.4645 145.718 96.2198 144.556 96.2198C143.395 96.2198 142.312 96.4645 141.317 96.869Z",
    fill: "url(#paint79_radial_3145_298)",
    fillOpacity: 0.2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 110.944V130.014H141.317V110.944C142.312 111.349 143.396 111.593 144.556 111.593C145.717 111.593 146.801 111.349 147.799 110.944Z",
    fill: "url(#paint80_radial_3145_298)",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 77.7968H135.216C133.934 77.7968 132.892 78.8338 132.892 80.1096V127.702C132.892 128.979 133.934 130.014 135.216 130.014H137.733V108.625C136.913 107.88 136.213 107.089 135.65 106.375C135.034 105.589 134.58 104.892 134.305 104.441C134.094 104.094 134.094 103.718 134.306 103.371C134.581 102.92 135.034 102.223 135.65 101.439C136.213 100.722 136.913 99.9315 137.733 99.1878V77.7968Z",
    fill: "url(#paint81_radial_3145_298)",
    fillOpacity: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 77.7968V130.016C127.595 130.016 125.887 128.315 125.887 126.218V81.5975C125.887 79.4987 127.595 77.7968 129.704 77.7968Z",
    fill: "url(#paint82_radial_3145_298)",
    fillOpacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 102.078C147.359 99.6714 146.073 97.929 144.556 97.929C143.042 97.929 141.758 99.6676 141.317 102.069C141.21 102.647 141.152 103.264 141.152 103.906C141.152 104.548 141.21 105.164 141.317 105.744C141.758 108.146 143.04 109.882 144.556 109.882C146.073 109.882 147.359 108.14 147.799 105.735C147.905 105.158 147.961 104.544 147.961 103.906C147.961 103.268 147.905 102.655 147.799 102.078Z",
    fill: "url(#paint83_radial_3145_298)",
    fillOpacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 81.5975V126.216C100.284 128.315 98.5738 130.014 96.4667 130.014V77.7968C98.5738 77.7968 100.284 79.4987 100.284 81.5975Z",
    fill: "url(#paint84_radial_3145_298)",
    fillOpacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 127.702V80.1096C93.2806 78.8338 92.239 77.7968 90.955 77.7968H88.439V99.1895C89.2621 99.9354 89.9595 100.726 90.523 101.442C90.9084 101.934 91.2299 102.389 91.4834 102.772C91.6349 103 91.7626 103.203 91.8651 103.371C92.0767 103.718 92.077 104.094 91.8654 104.441C91.7629 104.609 91.6352 104.812 91.4834 105.041C91.2299 105.424 90.9084 105.879 90.523 106.371C90.1764 106.812 89.7794 107.282 89.332 107.751C89.0529 108.043 88.7549 108.336 88.439 108.622V130.014H90.955C92.239 130.014 93.2806 128.979 93.2806 127.702Z",
    fill: "url(#paint85_radial_3145_298)",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 96.869V77.7968H84.8563V96.869C83.8608 96.4645 82.7762 96.2198 81.6142 96.2198C80.4522 96.2198 79.3697 96.4645 78.3743 96.869Z",
    fill: "url(#paint86_radial_3145_298)",
    fillOpacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 110.944V130.014H78.3743V110.944C79.3697 111.349 80.454 111.593 81.6142 111.593C82.7744 111.593 83.8587 111.349 84.8563 110.944Z",
    fill: "url(#paint87_radial_3145_298)",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 77.7968H72.2735C70.9915 77.7968 69.9496 78.8338 69.9496 80.1096V127.702C69.9496 128.979 70.9915 130.014 72.2735 130.014H74.7912V108.625C73.9702 107.88 73.271 107.089 72.7075 106.375C72.0916 105.589 71.6376 104.892 71.3626 104.441C71.1514 104.094 71.1517 103.718 71.3634 103.371C71.6383 102.92 72.0919 102.223 72.7075 101.439C73.271 100.722 73.9702 99.9315 74.7912 99.1878V77.7968Z",
    fill: "url(#paint88_radial_3145_298)",
    fillOpacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 77.7968V130.016C64.6529 130.016 62.9446 128.315 62.9446 126.218V81.5975C62.9446 79.4987 64.6529 77.7968 66.7617 77.7968Z",
    fill: "url(#paint89_radial_3145_298)",
    fillOpacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 102.078C84.4166 99.6714 83.1305 97.929 81.6142 97.929C80.0997 97.929 78.8157 99.6676 78.3743 102.069C78.2676 102.647 78.2095 103.264 78.2095 103.906C78.2095 104.548 78.2676 105.164 78.3743 105.744C78.8157 108.146 80.0979 109.882 81.6142 109.882C83.1305 109.882 84.4166 108.14 84.8563 105.735C84.9626 105.158 85.019 104.544 85.019 103.906C85.019 103.268 84.9626 102.655 84.8563 102.078Z",
    fill: "url(#paint90_radial_3145_298)",
    fillOpacity: 0.2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 81.5975V126.216C37.3392 128.315 35.6291 130.014 33.5221 130.014V77.7968C35.6291 77.7968 37.3392 79.4987 37.3392 81.5975Z",
    fill: "url(#paint91_radial_3145_298)",
    fillOpacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 127.702V80.1096C30.336 78.8338 29.2943 77.7968 28.0103 77.7968H25.4944V99.1895C26.3174 99.9354 27.0149 100.726 27.5784 101.442C27.9638 101.934 28.2852 102.389 28.5388 102.772C28.6902 103 28.8179 103.203 28.9204 103.371C29.132 103.718 29.1324 104.094 28.9208 104.441C28.8183 104.609 28.6906 104.812 28.5388 105.041C28.2852 105.424 27.9638 105.879 27.5784 106.371C27.2318 106.812 26.8347 107.282 26.3874 107.751C26.1082 108.043 25.8102 108.336 25.4944 108.622V130.014H28.0103C29.2943 130.014 30.336 128.979 30.336 127.702Z",
    fill: "url(#paint92_radial_3145_298)",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 96.869V77.7968H21.9116V96.869C20.9162 96.4645 19.8315 96.2198 18.6696 96.2198C17.5076 96.2198 16.4251 96.4645 15.4296 96.869Z",
    fill: "url(#paint93_radial_3145_298)",
    fillOpacity: 0.2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 110.944V130.014H15.4296V110.944C16.4251 111.349 17.5094 111.593 18.6696 111.593C19.8298 111.593 20.9141 111.349 21.9116 110.944Z",
    fill: "url(#paint94_radial_3145_298)",
    fillOpacity: 0.2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 77.7968H9.32883C8.04691 77.7968 7.00491 78.8338 7.00491 80.1096V127.702C7.00491 128.979 8.04691 130.014 9.32883 130.014H11.8465V108.625C11.0256 107.88 10.3264 107.089 9.76291 106.375C9.14694 105.589 8.6929 104.892 8.418 104.441C8.20673 104.094 8.20712 103.718 8.41873 103.371C8.69366 102.92 9.14731 102.223 9.76291 101.439C10.3264 100.722 11.0256 99.9315 11.8465 99.1878V77.7968Z",
    fill: "url(#paint95_radial_3145_298)",
    fillOpacity: 0.2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 77.7968V130.016C1.70831 130.016 0 128.315 0 126.218V81.5975C0 79.4987 1.70831 77.7968 3.81711 77.7968Z",
    fill: "url(#paint96_radial_3145_298)",
    fillOpacity: 0.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 102.078C21.472 99.6714 20.1859 97.929 18.6696 97.929C17.155 97.929 15.871 99.6676 15.4296 102.069C15.3229 102.647 15.2649 103.264 15.2649 103.906C15.2649 104.548 15.3229 105.164 15.4296 105.744C15.871 108.146 17.1533 109.882 18.6696 109.882C20.1859 109.882 21.472 108.14 21.9116 105.735C22.0179 105.158 22.0743 104.544 22.0743 103.906C22.0743 103.268 22.0179 102.655 21.9116 102.078Z",
    fill: "url(#paint97_radial_3145_298)",
    fillOpacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M415 159.394V204.013C415 206.111 413.29 207.811 411.183 207.811V155.594C413.29 155.594 415 157.295 415 159.394Z",
    fill: "url(#paint98_radial_3145_298)",
    fillOpacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 205.499V157.906C407.997 156.631 406.955 155.594 405.671 155.594H403.155V176.986C403.978 177.732 404.676 178.522 405.239 179.239C405.625 179.731 405.946 180.186 406.2 180.569C406.351 180.797 406.479 180.999 406.581 181.168C406.793 181.514 406.793 181.891 406.582 182.238C406.479 182.406 406.351 182.609 406.2 182.838C405.946 183.221 405.625 183.676 405.239 184.168C404.893 184.609 404.496 185.079 404.048 185.547C403.769 185.84 403.471 186.133 403.155 186.418V207.811H405.671C406.955 207.811 407.997 206.776 407.997 205.499Z",
    fill: "url(#paint99_radial_3145_298)",
    fillOpacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 174.666V155.594H399.572V174.666C398.577 174.261 397.492 174.017 396.33 174.017C395.168 174.017 394.086 174.261 393.09 174.666Z",
    fill: "url(#paint100_radial_3145_298)",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 188.741V207.811H393.09V188.741C394.086 189.145 395.17 189.39 396.33 189.39C397.491 189.39 398.575 189.145 399.572 188.741Z",
    fill: "url(#paint101_radial_3145_298)",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 155.594H386.99C385.708 155.594 384.666 156.631 384.666 157.906V205.499C384.666 206.776 385.708 207.811 386.99 207.811H389.507V186.422C388.686 185.676 387.987 184.886 387.424 184.171C386.808 183.386 386.354 182.689 386.079 182.238C385.868 181.891 385.868 181.514 386.08 181.167C386.354 180.717 386.808 180.02 387.424 179.235C387.987 178.518 388.686 177.728 389.507 176.985V155.594Z",
    fill: "url(#paint102_radial_3145_298)",
    fillOpacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 155.594V207.813C379.369 207.813 377.661 206.111 377.661 204.015V159.394C377.661 157.295 379.369 155.594 381.478 155.594Z",
    fill: "url(#paint103_radial_3145_298)",
    fillOpacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 179.875C399.133 177.468 397.847 175.726 396.33 175.726C394.816 175.726 393.532 177.464 393.09 179.866C392.984 180.444 392.926 181.061 392.926 181.702C392.926 182.344 392.984 182.961 393.09 183.541C393.532 185.942 394.814 187.679 396.33 187.679C397.847 187.679 399.133 185.937 399.572 183.532C399.679 182.955 399.735 182.34 399.735 181.702C399.735 181.065 399.679 180.452 399.572 179.875Z",
    fill: "url(#paint104_radial_3145_298)",
    fillOpacity: 0.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 159.394V204.013C352.058 206.111 350.348 207.811 348.241 207.811V155.594C350.348 155.594 352.058 157.295 352.058 159.394Z",
    fill: "url(#paint105_radial_3145_298)",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 205.499V157.906C345.054 156.631 344.013 155.594 342.729 155.594H340.213V176.986C341.036 177.732 341.733 178.522 342.297 179.239C342.682 179.731 343.004 180.186 343.257 180.569C343.409 180.797 343.536 180.999 343.639 181.168C343.851 181.514 343.851 181.891 343.639 182.238C343.537 182.406 343.409 182.609 343.257 182.838C343.004 183.221 342.682 183.676 342.297 184.168C341.95 184.609 341.553 185.079 341.106 185.547C340.827 185.84 340.529 186.133 340.213 186.418V207.811H342.729C344.013 207.811 345.054 206.776 345.054 205.499Z",
    fill: "url(#paint106_radial_3145_298)",
    fillOpacity: 0.2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 174.666V155.594H336.63V174.666C335.635 174.261 334.55 174.017 333.388 174.017C332.226 174.017 331.144 174.261 330.148 174.666Z",
    fill: "url(#paint107_radial_3145_298)",
    fillOpacity: 0.2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 188.741V207.811H330.148V188.741C331.144 189.145 332.228 189.39 333.388 189.39C334.548 189.39 335.633 189.145 336.63 188.741Z",
    fill: "url(#paint108_radial_3145_298)",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 155.594H324.047C322.765 155.594 321.723 156.631 321.723 157.906V205.499C321.723 206.776 322.765 207.811 324.047 207.811H326.565V186.422C325.744 185.676 325.045 184.886 324.481 184.171C323.865 183.386 323.411 182.689 323.137 182.238C322.925 181.891 322.926 181.514 323.137 181.167C323.412 180.717 323.866 180.02 324.481 179.235C325.045 178.518 325.744 177.728 326.565 176.985V155.594Z",
    fill: "url(#paint109_radial_3145_298)",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 155.594V207.813C316.427 207.813 314.718 206.111 314.718 204.015V159.394C314.718 157.295 316.427 155.594 318.536 155.594Z",
    fill: "url(#paint110_radial_3145_298)",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 179.875C336.19 177.468 334.904 175.726 333.388 175.726C331.874 175.726 330.59 177.464 330.148 179.866C330.041 180.444 329.983 181.061 329.983 181.702C329.983 182.344 330.041 182.961 330.148 183.541C330.59 185.942 331.872 187.679 333.388 187.679C334.904 187.679 336.19 185.937 336.63 183.532C336.736 182.955 336.793 182.34 336.793 181.702C336.793 181.065 336.736 180.452 336.63 179.875Z",
    fill: "url(#paint111_radial_3145_298)",
    fillOpacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 159.394V204.013C289.111 206.111 287.401 207.811 285.294 207.811V155.594C287.401 155.594 289.111 157.295 289.111 159.394Z",
    fill: "url(#paint112_radial_3145_298)",
    fillOpacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 205.499V157.906C282.108 156.631 281.066 155.594 279.782 155.594H277.266V176.986C278.089 177.732 278.786 178.522 279.35 179.239C279.735 179.731 280.057 180.186 280.31 180.569C280.462 180.797 280.59 180.999 280.692 181.168C280.904 181.514 280.904 181.891 280.692 182.238C280.59 182.406 280.462 182.609 280.31 182.838C280.057 183.221 279.735 183.676 279.35 184.168C279.003 184.609 278.606 185.079 278.159 185.547C277.88 185.84 277.582 186.133 277.266 186.418V207.811H279.782C281.066 207.811 282.108 206.776 282.108 205.499Z",
    fill: "url(#paint113_radial_3145_298)",
    fillOpacity: 0.2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 174.666V155.594H273.683V174.666C272.688 174.261 271.603 174.017 270.441 174.017C269.279 174.017 268.197 174.261 267.201 174.666Z",
    fill: "url(#paint114_radial_3145_298)",
    fillOpacity: 0.2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 188.741V207.811H267.201V188.741C268.197 189.145 269.281 189.39 270.441 189.39C271.601 189.39 272.686 189.145 273.683 188.741Z",
    fill: "url(#paint115_radial_3145_298)",
    fillOpacity: 0.2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 155.594H261.1C259.818 155.594 258.776 156.631 258.776 157.906V205.499C258.776 206.776 259.818 207.811 261.1 207.811H263.618V186.422C262.797 185.676 262.098 184.886 261.534 184.171C260.919 183.386 260.464 182.689 260.19 182.238C259.978 181.891 259.979 181.514 260.19 181.167C260.465 180.717 260.919 180.02 261.534 179.235C262.098 178.518 262.797 177.728 263.618 176.985V155.594Z",
    fill: "url(#paint116_radial_3145_298)",
    fillOpacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 155.594V207.813C253.48 207.813 251.772 206.111 251.772 204.015V159.394C251.772 157.295 253.48 155.594 255.589 155.594Z",
    fill: "url(#paint117_radial_3145_298)",
    fillOpacity: 0.2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 179.875C273.244 177.468 271.957 175.726 270.441 175.726C268.927 175.726 267.643 177.464 267.201 179.866C267.094 180.444 267.036 181.061 267.036 181.702C267.036 182.344 267.094 182.961 267.201 183.541C267.643 185.942 268.925 187.679 270.441 187.679C271.957 187.679 273.244 185.937 273.683 183.532C273.79 182.955 273.846 182.34 273.846 181.702C273.846 181.065 273.79 180.452 273.683 179.875Z",
    fill: "url(#paint118_radial_3145_298)",
    fillOpacity: 0.2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 159.394V204.013C226.173 206.111 224.463 207.811 222.356 207.811V155.594C224.463 155.594 226.173 157.295 226.173 159.394Z",
    fill: "url(#paint119_radial_3145_298)",
    fillOpacity: 0.2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 205.499V157.906C219.17 156.631 218.128 155.594 216.844 155.594H214.328V176.986C215.151 177.732 215.849 178.522 216.412 179.239C216.798 179.731 217.119 180.186 217.373 180.569C217.524 180.797 217.652 180.999 217.754 181.168C217.966 181.514 217.966 181.891 217.755 182.238C217.652 182.406 217.525 182.609 217.373 182.838C217.119 183.221 216.798 183.676 216.412 184.168C216.066 184.609 215.669 185.079 215.221 185.547C214.942 185.84 214.644 186.133 214.328 186.418V207.811H216.844C218.128 207.811 219.17 206.776 219.17 205.499Z",
    fill: "url(#paint120_radial_3145_298)",
    fillOpacity: 0.2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 174.666V155.594H210.746V174.666C209.75 174.261 208.665 174.017 207.503 174.017C206.342 174.017 205.259 174.261 204.263 174.666Z",
    fill: "url(#paint121_radial_3145_298)",
    fillOpacity: 0.2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 188.741V207.811H204.263V188.741C205.259 189.145 206.343 189.39 207.503 189.39C208.664 189.39 209.748 189.145 210.746 188.741Z",
    fill: "url(#paint122_radial_3145_298)",
    fillOpacity: 0.2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 155.594H198.163C196.881 155.594 195.839 156.631 195.839 157.906V205.499C195.839 206.776 196.881 207.811 198.163 207.811H200.68V186.422C199.859 185.676 199.16 184.886 198.597 184.171C197.981 183.386 197.527 182.689 197.252 182.238C197.041 181.891 197.041 181.514 197.253 181.167C197.528 180.717 197.981 180.02 198.597 179.235C199.16 178.518 199.859 177.728 200.68 176.985V155.594Z",
    fill: "url(#paint123_radial_3145_298)",
    fillOpacity: 0.2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 155.594V207.813C190.542 207.813 188.834 206.111 188.834 204.015V159.394C188.834 157.295 190.542 155.594 192.651 155.594Z",
    fill: "url(#paint124_radial_3145_298)",
    fillOpacity: 0.2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 179.875C210.306 177.468 209.02 175.726 207.503 175.726C205.989 175.726 204.705 177.464 204.263 179.866C204.157 180.444 204.099 181.061 204.099 181.702C204.099 182.344 204.157 182.961 204.263 183.541C204.705 185.942 205.987 187.679 207.503 187.679C209.02 187.679 210.306 185.937 210.746 183.532C210.852 182.955 210.908 182.34 210.908 181.702C210.908 181.065 210.852 180.452 210.746 179.875Z",
    fill: "url(#paint125_radial_3145_298)",
    fillOpacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 159.394V204.013C163.226 206.111 161.516 207.811 159.409 207.811V155.594C161.516 155.594 163.226 157.295 163.226 159.394Z",
    fill: "url(#paint126_radial_3145_298)",
    fillOpacity: 0.2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 205.499V157.906C156.223 156.631 155.181 155.594 153.897 155.594H151.381V176.986C152.204 177.732 152.902 178.522 153.465 179.239C153.851 179.731 154.172 180.186 154.426 180.569C154.577 180.797 154.705 180.999 154.807 181.168C155.019 181.514 155.019 181.891 154.808 182.238C154.705 182.406 154.578 182.609 154.426 182.838C154.172 183.221 153.851 183.676 153.465 184.168C153.119 184.609 152.722 185.079 152.274 185.547C151.995 185.84 151.697 186.133 151.381 186.418V207.811H153.897C155.181 207.811 156.223 206.776 156.223 205.499Z",
    fill: "url(#paint127_radial_3145_298)",
    fillOpacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 174.666V155.594H147.799V174.666C146.803 174.261 145.718 174.017 144.556 174.017C143.395 174.017 142.312 174.261 141.317 174.666Z",
    fill: "url(#paint128_radial_3145_298)",
    fillOpacity: 0.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 188.741V207.811H141.317V188.741C142.312 189.145 143.396 189.39 144.556 189.39C145.717 189.39 146.801 189.145 147.799 188.741Z",
    fill: "url(#paint129_radial_3145_298)",
    fillOpacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 155.594H135.216C133.934 155.594 132.892 156.631 132.892 157.906V205.499C132.892 206.776 133.934 207.811 135.216 207.811H137.733V186.422C136.913 185.676 136.213 184.886 135.65 184.171C135.034 183.386 134.58 182.689 134.305 182.238C134.094 181.891 134.094 181.514 134.306 181.167C134.581 180.717 135.034 180.02 135.65 179.235C136.213 178.518 136.913 177.728 137.733 176.985V155.594Z",
    fill: "url(#paint130_radial_3145_298)",
    fillOpacity: 0.2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 155.594V207.813C127.595 207.813 125.887 206.111 125.887 204.015V159.394C125.887 157.295 127.595 155.594 129.704 155.594Z",
    fill: "url(#paint131_radial_3145_298)",
    fillOpacity: 0.2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 179.875C147.359 177.468 146.073 175.726 144.556 175.726C143.042 175.726 141.758 177.464 141.317 179.866C141.21 180.444 141.152 181.061 141.152 181.702C141.152 182.344 141.21 182.961 141.317 183.541C141.758 185.942 143.04 187.679 144.556 187.679C146.073 187.679 147.359 185.937 147.799 183.532C147.905 182.955 147.961 182.34 147.961 181.702C147.961 181.065 147.905 180.452 147.799 179.875Z",
    fill: "url(#paint132_radial_3145_298)",
    fillOpacity: 0.2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 159.394V204.013C100.284 206.111 98.5738 207.811 96.4667 207.811V155.594C98.5738 155.594 100.284 157.295 100.284 159.394Z",
    fill: "url(#paint133_radial_3145_298)",
    fillOpacity: 0.2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 205.499V157.906C93.2806 156.631 92.239 155.594 90.955 155.594H88.439V176.986C89.2621 177.732 89.9595 178.522 90.523 179.239C90.9084 179.731 91.2299 180.186 91.4834 180.569C91.6349 180.797 91.7626 180.999 91.8651 181.168C92.0767 181.514 92.077 181.891 91.8654 182.238C91.7629 182.406 91.6352 182.609 91.4834 182.838C91.2299 183.221 90.9084 183.676 90.523 184.168C90.1764 184.609 89.7794 185.079 89.332 185.547C89.0529 185.84 88.7549 186.133 88.439 186.418V207.811H90.955C92.239 207.811 93.2806 206.776 93.2806 205.499Z",
    fill: "url(#paint134_radial_3145_298)",
    fillOpacity: 0.2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 174.666V155.594H84.8563V174.666C83.8608 174.261 82.7762 174.017 81.6142 174.017C80.4522 174.017 79.3697 174.261 78.3743 174.666Z",
    fill: "url(#paint135_radial_3145_298)",
    fillOpacity: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 188.741V207.811H78.3743V188.741C79.3697 189.145 80.454 189.39 81.6142 189.39C82.7744 189.39 83.8587 189.145 84.8563 188.741Z",
    fill: "url(#paint136_radial_3145_298)",
    fillOpacity: 0.2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 155.594H72.2735C70.9915 155.594 69.9496 156.631 69.9496 157.906V205.499C69.9496 206.776 70.9915 207.811 72.2735 207.811H74.7912V186.422C73.9702 185.676 73.271 184.886 72.7075 184.171C72.0916 183.386 71.6376 182.689 71.3626 182.238C71.1514 181.891 71.1517 181.514 71.3634 181.167C71.6383 180.717 72.0919 180.02 72.7075 179.235C73.271 178.518 73.9702 177.728 74.7912 176.985V155.594Z",
    fill: "url(#paint137_radial_3145_298)",
    fillOpacity: 0.2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 155.594V207.813C64.6529 207.813 62.9446 206.111 62.9446 204.015V159.394C62.9446 157.295 64.6529 155.594 66.7617 155.594Z",
    fill: "url(#paint138_radial_3145_298)",
    fillOpacity: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 179.875C84.4166 177.468 83.1305 175.726 81.6142 175.726C80.0997 175.726 78.8157 177.464 78.3743 179.866C78.2676 180.444 78.2095 181.061 78.2095 181.702C78.2095 182.344 78.2676 182.961 78.3743 183.541C78.8157 185.942 80.0979 187.679 81.6142 187.679C83.1305 187.679 84.4166 185.937 84.8563 183.532C84.9626 182.955 85.019 182.34 85.019 181.702C85.019 181.065 84.9626 180.452 84.8563 179.875Z",
    fill: "url(#paint139_radial_3145_298)",
    fillOpacity: 0.2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 159.394V204.013C37.3392 206.111 35.6291 207.811 33.5221 207.811V155.594C35.6291 155.594 37.3392 157.295 37.3392 159.394Z",
    fill: "url(#paint140_radial_3145_298)",
    fillOpacity: 0.2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 205.499V157.906C30.336 156.631 29.2943 155.594 28.0103 155.594H25.4944V176.986C26.3174 177.732 27.0149 178.522 27.5784 179.239C27.9638 179.731 28.2852 180.186 28.5388 180.569C28.6902 180.797 28.8179 180.999 28.9204 181.168C29.132 181.514 29.1324 181.891 28.9208 182.238C28.8183 182.406 28.6906 182.609 28.5388 182.838C28.2852 183.221 27.9638 183.676 27.5784 184.168C27.2318 184.609 26.8347 185.079 26.3874 185.547C26.1082 185.84 25.8102 186.133 25.4944 186.418V207.811H28.0103C29.2943 207.811 30.336 206.776 30.336 205.499Z",
    fill: "url(#paint141_radial_3145_298)",
    fillOpacity: 0.2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 174.666V155.594H21.9116V174.666C20.9162 174.261 19.8315 174.017 18.6696 174.017C17.5076 174.017 16.4251 174.261 15.4296 174.666Z",
    fill: "url(#paint142_radial_3145_298)",
    fillOpacity: 0.2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 188.741V207.811H15.4296V188.741C16.4251 189.145 17.5094 189.39 18.6696 189.39C19.8298 189.39 20.9141 189.145 21.9116 188.741Z",
    fill: "url(#paint143_radial_3145_298)",
    fillOpacity: 0.2
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 155.594H9.32883C8.04691 155.594 7.00491 156.631 7.00491 157.906V205.499C7.00491 206.776 8.04691 207.811 9.32883 207.811H11.8465V186.422C11.0256 185.676 10.3264 184.886 9.76291 184.171C9.14694 183.386 8.6929 182.689 8.418 182.238C8.20673 181.891 8.20712 181.514 8.41873 181.167C8.69366 180.717 9.14731 180.02 9.76291 179.235C10.3264 178.518 11.0256 177.728 11.8465 176.985V155.594Z",
    fill: "url(#paint144_radial_3145_298)",
    fillOpacity: 0.2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 155.594V207.813C1.70831 207.813 0 206.111 0 204.015V159.394C0 157.295 1.70831 155.594 3.81711 155.594Z",
    fill: "url(#paint145_radial_3145_298)",
    fillOpacity: 0.2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 179.875C21.472 177.468 20.1859 175.726 18.6696 175.726C17.155 175.726 15.871 177.464 15.4296 179.866C15.3229 180.444 15.2649 181.061 15.2649 181.702C15.2649 182.344 15.3229 182.961 15.4296 183.541C15.871 185.942 17.1533 187.679 18.6696 187.679C20.1859 187.679 21.472 185.937 21.9116 183.532C22.0179 182.955 22.0743 182.34 22.0743 181.702C22.0743 181.065 22.0179 180.452 21.9116 179.875Z",
    fill: "url(#paint146_radial_3145_298)",
    fillOpacity: 0.2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M415 237.191V281.809C415 283.908 413.29 285.608 411.183 285.608V233.39C413.29 233.39 415 235.092 415 237.191Z",
    fill: "url(#paint147_radial_3145_298)",
    fillOpacity: 0.2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 283.295V235.703C407.997 234.427 406.955 233.39 405.671 233.39H403.155V254.783C403.978 255.529 404.676 256.319 405.239 257.036C405.625 257.527 405.946 257.982 406.2 258.366C406.351 258.594 406.479 258.796 406.581 258.964C406.793 259.311 406.793 259.687 406.582 260.034C406.479 260.202 406.351 260.405 406.2 260.634C405.946 261.018 405.625 261.473 405.239 261.964C404.893 262.405 404.496 262.876 404.048 263.344C403.769 263.637 403.471 263.93 403.155 264.215V285.608H405.671C406.955 285.608 407.997 284.573 407.997 283.295Z",
    fill: "url(#paint148_radial_3145_298)",
    fillOpacity: 0.2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 252.462V233.39H399.572V252.462C398.577 252.058 397.492 251.813 396.33 251.813C395.168 251.813 394.086 252.058 393.09 252.462Z",
    fill: "url(#paint149_radial_3145_298)",
    fillOpacity: 0.2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 266.538V285.608H393.09V266.538C394.086 266.942 395.17 267.187 396.33 267.187C397.491 267.187 398.575 266.942 399.572 266.538Z",
    fill: "url(#paint150_radial_3145_298)",
    fillOpacity: 0.2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 233.39H386.99C385.708 233.39 384.666 234.427 384.666 235.703V283.295C384.666 284.573 385.708 285.608 386.99 285.608H389.507V264.219C388.686 263.473 387.987 262.683 387.424 261.968C386.808 261.182 386.354 260.486 386.079 260.035C385.868 259.687 385.868 259.311 386.08 258.964C386.354 258.513 386.808 257.817 387.424 257.032C387.987 256.315 388.686 255.525 389.507 254.781V233.39Z",
    fill: "url(#paint151_radial_3145_298)",
    fillOpacity: 0.2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 233.39V285.61C379.369 285.61 377.661 283.908 377.661 281.811V237.191C377.661 235.092 379.369 233.39 381.478 233.39Z",
    fill: "url(#paint152_radial_3145_298)",
    fillOpacity: 0.2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 257.672C399.133 255.265 397.847 253.522 396.33 253.522C394.816 253.522 393.532 255.261 393.09 257.662C392.984 258.241 392.926 258.857 392.926 259.499C392.926 260.141 392.984 260.758 393.09 261.338C393.532 263.739 394.814 265.475 396.33 265.475C397.847 265.475 399.133 263.733 399.572 261.328C399.679 260.752 399.735 260.137 399.735 259.499C399.735 258.861 399.679 258.248 399.572 257.672Z",
    fill: "url(#paint153_radial_3145_298)",
    fillOpacity: 0.2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 237.191V281.809C352.058 283.908 350.348 285.608 348.241 285.608V233.39C350.348 233.39 352.058 235.092 352.058 237.191Z",
    fill: "url(#paint154_radial_3145_298)",
    fillOpacity: 0.2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 283.295V235.703C345.054 234.427 344.013 233.39 342.729 233.39H340.213V254.783C341.036 255.529 341.733 256.319 342.297 257.036C342.682 257.527 343.004 257.982 343.257 258.366C343.409 258.594 343.536 258.796 343.639 258.964C343.851 259.311 343.851 259.687 343.639 260.034C343.537 260.202 343.409 260.405 343.257 260.634C343.004 261.018 342.682 261.473 342.297 261.964C341.95 262.405 341.553 262.876 341.106 263.344C340.827 263.637 340.529 263.93 340.213 264.215V285.608H342.729C344.013 285.608 345.054 284.573 345.054 283.295Z",
    fill: "url(#paint155_radial_3145_298)",
    fillOpacity: 0.2
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 252.462V233.39H336.63V252.462C335.635 252.058 334.55 251.813 333.388 251.813C332.226 251.813 331.144 252.058 330.148 252.462Z",
    fill: "url(#paint156_radial_3145_298)",
    fillOpacity: 0.2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 266.538V285.608H330.148V266.538C331.144 266.942 332.228 267.187 333.388 267.187C334.548 267.187 335.633 266.942 336.63 266.538Z",
    fill: "url(#paint157_radial_3145_298)",
    fillOpacity: 0.2
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 233.39H324.047C322.765 233.39 321.723 234.427 321.723 235.703V283.295C321.723 284.573 322.765 285.608 324.047 285.608H326.565V264.219C325.744 263.473 325.045 262.683 324.481 261.968C323.865 261.182 323.411 260.486 323.137 260.035C322.925 259.687 322.926 259.311 323.137 258.964C323.412 258.513 323.866 257.817 324.481 257.032C325.045 256.315 325.744 255.525 326.565 254.781V233.39Z",
    fill: "url(#paint158_radial_3145_298)",
    fillOpacity: 0.2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 233.39V285.61C316.427 285.61 314.718 283.908 314.718 281.811V237.191C314.718 235.092 316.427 233.39 318.536 233.39Z",
    fill: "url(#paint159_radial_3145_298)",
    fillOpacity: 0.2
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 257.672C336.19 255.265 334.904 253.522 333.388 253.522C331.874 253.522 330.59 255.261 330.148 257.662C330.041 258.241 329.983 258.857 329.983 259.499C329.983 260.141 330.041 260.758 330.148 261.338C330.59 263.739 331.872 265.475 333.388 265.475C334.904 265.475 336.19 263.733 336.63 261.328C336.736 260.752 336.793 260.137 336.793 259.499C336.793 258.861 336.736 258.248 336.63 257.672Z",
    fill: "url(#paint160_radial_3145_298)",
    fillOpacity: 0.2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 237.191V281.809C289.111 283.908 287.401 285.608 285.294 285.608V233.39C287.401 233.39 289.111 235.092 289.111 237.191Z",
    fill: "url(#paint161_radial_3145_298)",
    fillOpacity: 0.2
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 283.295V235.703C282.108 234.427 281.066 233.39 279.782 233.39H277.266V254.783C278.089 255.529 278.786 256.319 279.35 257.036C279.735 257.527 280.057 257.982 280.31 258.366C280.462 258.594 280.59 258.796 280.692 258.964C280.904 259.311 280.904 259.687 280.692 260.034C280.59 260.202 280.462 260.405 280.31 260.634C280.057 261.018 279.735 261.473 279.35 261.964C279.003 262.405 278.606 262.876 278.159 263.344C277.88 263.637 277.582 263.93 277.266 264.215V285.608H279.782C281.066 285.608 282.108 284.573 282.108 283.295Z",
    fill: "url(#paint162_radial_3145_298)",
    fillOpacity: 0.2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 252.462V233.39H273.683V252.462C272.688 252.058 271.603 251.813 270.441 251.813C269.279 251.813 268.197 252.058 267.201 252.462Z",
    fill: "url(#paint163_radial_3145_298)",
    fillOpacity: 0.2
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 266.538V285.608H267.201V266.538C268.197 266.942 269.281 267.187 270.441 267.187C271.601 267.187 272.686 266.942 273.683 266.538Z",
    fill: "url(#paint164_radial_3145_298)",
    fillOpacity: 0.2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 233.39H261.1C259.818 233.39 258.776 234.427 258.776 235.703V283.295C258.776 284.573 259.818 285.608 261.1 285.608H263.618V264.219C262.797 263.473 262.098 262.683 261.534 261.968C260.919 261.182 260.464 260.486 260.19 260.035C259.978 259.687 259.979 259.311 260.19 258.964C260.465 258.513 260.919 257.817 261.534 257.032C262.098 256.315 262.797 255.525 263.618 254.781V233.39Z",
    fill: "url(#paint165_radial_3145_298)",
    fillOpacity: 0.2
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 233.39V285.61C253.48 285.61 251.772 283.908 251.772 281.811V237.191C251.772 235.092 253.48 233.39 255.589 233.39Z",
    fill: "url(#paint166_radial_3145_298)",
    fillOpacity: 0.2
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 257.672C273.244 255.265 271.957 253.522 270.441 253.522C268.927 253.522 267.643 255.261 267.201 257.662C267.094 258.241 267.036 258.857 267.036 259.499C267.036 260.141 267.094 260.758 267.201 261.338C267.643 263.739 268.925 265.475 270.441 265.475C271.957 265.475 273.244 263.733 273.683 261.328C273.79 260.752 273.846 260.137 273.846 259.499C273.846 258.861 273.79 258.248 273.683 257.672Z",
    fill: "url(#paint167_radial_3145_298)",
    fillOpacity: 0.2
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 237.191V281.809C226.173 283.908 224.463 285.608 222.356 285.608V233.39C224.463 233.39 226.173 235.092 226.173 237.191Z",
    fill: "url(#paint168_radial_3145_298)",
    fillOpacity: 0.2
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 283.295V235.703C219.17 234.427 218.128 233.39 216.844 233.39H214.328V254.783C215.151 255.529 215.849 256.319 216.412 257.036C216.798 257.527 217.119 257.982 217.373 258.366C217.524 258.594 217.652 258.796 217.754 258.964C217.966 259.311 217.966 259.687 217.755 260.034C217.652 260.202 217.525 260.405 217.373 260.634C217.119 261.018 216.798 261.473 216.412 261.964C216.066 262.405 215.669 262.876 215.221 263.344C214.942 263.637 214.644 263.93 214.328 264.215V285.608H216.844C218.128 285.608 219.17 284.573 219.17 283.295Z",
    fill: "url(#paint169_radial_3145_298)",
    fillOpacity: 0.2
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 252.462V233.39H210.746V252.462C209.75 252.058 208.665 251.813 207.503 251.813C206.342 251.813 205.259 252.058 204.263 252.462Z",
    fill: "url(#paint170_radial_3145_298)",
    fillOpacity: 0.2
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 266.538V285.608H204.263V266.538C205.259 266.942 206.343 267.187 207.503 267.187C208.664 267.187 209.748 266.942 210.746 266.538Z",
    fill: "url(#paint171_radial_3145_298)",
    fillOpacity: 0.2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 233.39H198.163C196.881 233.39 195.839 234.427 195.839 235.703V283.295C195.839 284.573 196.881 285.608 198.163 285.608H200.68V264.219C199.859 263.473 199.16 262.683 198.597 261.968C197.981 261.182 197.527 260.486 197.252 260.035C197.041 259.687 197.041 259.311 197.253 258.964C197.528 258.513 197.981 257.817 198.597 257.032C199.16 256.315 199.859 255.525 200.68 254.781V233.39Z",
    fill: "url(#paint172_radial_3145_298)",
    fillOpacity: 0.2
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 233.39V285.61C190.542 285.61 188.834 283.908 188.834 281.811V237.191C188.834 235.092 190.542 233.39 192.651 233.39Z",
    fill: "url(#paint173_radial_3145_298)",
    fillOpacity: 0.2
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 257.672C210.306 255.265 209.02 253.522 207.503 253.522C205.989 253.522 204.705 255.261 204.263 257.662C204.157 258.241 204.099 258.857 204.099 259.499C204.099 260.141 204.157 260.758 204.263 261.338C204.705 263.739 205.987 265.475 207.503 265.475C209.02 265.475 210.306 263.733 210.746 261.328C210.852 260.752 210.908 260.137 210.908 259.499C210.908 258.861 210.852 258.248 210.746 257.672Z",
    fill: "url(#paint174_radial_3145_298)",
    fillOpacity: 0.2
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 237.191V281.809C163.226 283.908 161.516 285.608 159.409 285.608V233.39C161.516 233.39 163.226 235.092 163.226 237.191Z",
    fill: "url(#paint175_radial_3145_298)",
    fillOpacity: 0.2
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 283.295V235.703C156.223 234.427 155.181 233.39 153.897 233.39H151.381V254.783C152.204 255.529 152.902 256.319 153.465 257.036C153.851 257.527 154.172 257.982 154.426 258.366C154.577 258.594 154.705 258.796 154.807 258.964C155.019 259.311 155.019 259.687 154.808 260.034C154.705 260.202 154.578 260.405 154.426 260.634C154.172 261.018 153.851 261.473 153.465 261.964C153.119 262.405 152.722 262.876 152.274 263.344C151.995 263.637 151.697 263.93 151.381 264.215V285.608H153.897C155.181 285.608 156.223 284.573 156.223 283.295Z",
    fill: "url(#paint176_radial_3145_298)",
    fillOpacity: 0.2
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 252.462V233.39H147.799V252.462C146.803 252.058 145.718 251.813 144.556 251.813C143.395 251.813 142.312 252.058 141.317 252.462Z",
    fill: "url(#paint177_radial_3145_298)",
    fillOpacity: 0.2
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 266.538V285.608H141.317V266.538C142.312 266.942 143.396 267.187 144.556 267.187C145.717 267.187 146.801 266.942 147.799 266.538Z",
    fill: "url(#paint178_radial_3145_298)",
    fillOpacity: 0.2
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 233.39H135.216C133.934 233.39 132.892 234.427 132.892 235.703V283.295C132.892 284.573 133.934 285.608 135.216 285.608H137.733V264.219C136.913 263.473 136.213 262.683 135.65 261.968C135.034 261.182 134.58 260.486 134.305 260.035C134.094 259.687 134.094 259.311 134.306 258.964C134.581 258.513 135.034 257.817 135.65 257.032C136.213 256.315 136.913 255.525 137.733 254.781V233.39Z",
    fill: "url(#paint179_radial_3145_298)",
    fillOpacity: 0.2
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 233.39V285.61C127.595 285.61 125.887 283.908 125.887 281.811V237.191C125.887 235.092 127.595 233.39 129.704 233.39Z",
    fill: "url(#paint180_radial_3145_298)",
    fillOpacity: 0.2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 257.672C147.359 255.265 146.073 253.522 144.556 253.522C143.042 253.522 141.758 255.261 141.317 257.662C141.21 258.241 141.152 258.857 141.152 259.499C141.152 260.141 141.21 260.758 141.317 261.338C141.758 263.739 143.04 265.475 144.556 265.475C146.073 265.475 147.359 263.733 147.799 261.328C147.905 260.752 147.961 260.137 147.961 259.499C147.961 258.861 147.905 258.248 147.799 257.672Z",
    fill: "url(#paint181_radial_3145_298)",
    fillOpacity: 0.2
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 237.191V281.809C100.284 283.908 98.5738 285.608 96.4667 285.608V233.39C98.5738 233.39 100.284 235.092 100.284 237.191Z",
    fill: "url(#paint182_radial_3145_298)",
    fillOpacity: 0.2
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 283.295V235.703C93.2806 234.427 92.239 233.39 90.955 233.39H88.439V254.783C89.2621 255.529 89.9595 256.319 90.523 257.036C90.9084 257.527 91.2299 257.982 91.4834 258.366C91.6349 258.594 91.7626 258.796 91.8651 258.964C92.0767 259.311 92.077 259.687 91.8654 260.034C91.7629 260.202 91.6352 260.405 91.4834 260.634C91.2299 261.018 90.9084 261.473 90.523 261.964C90.1764 262.405 89.7794 262.876 89.332 263.344C89.0529 263.637 88.7549 263.93 88.439 264.215V285.608H90.955C92.239 285.608 93.2806 284.573 93.2806 283.295Z",
    fill: "url(#paint183_radial_3145_298)",
    fillOpacity: 0.2
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 252.462V233.39H84.8563V252.462C83.8608 252.058 82.7762 251.813 81.6142 251.813C80.4522 251.813 79.3697 252.058 78.3743 252.462Z",
    fill: "url(#paint184_radial_3145_298)",
    fillOpacity: 0.2
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 266.538V285.608H78.3743V266.538C79.3697 266.942 80.454 267.187 81.6142 267.187C82.7744 267.187 83.8587 266.942 84.8563 266.538Z",
    fill: "url(#paint185_radial_3145_298)",
    fillOpacity: 0.2
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 233.39H72.2735C70.9915 233.39 69.9496 234.427 69.9496 235.703V283.295C69.9496 284.573 70.9915 285.608 72.2735 285.608H74.7912V264.219C73.9702 263.473 73.271 262.683 72.7075 261.968C72.0916 261.182 71.6376 260.486 71.3626 260.035C71.1514 259.687 71.1517 259.311 71.3634 258.964C71.6383 258.513 72.0919 257.817 72.7075 257.032C73.271 256.315 73.9702 255.525 74.7912 254.781V233.39Z",
    fill: "url(#paint186_radial_3145_298)",
    fillOpacity: 0.2
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 233.39V285.61C64.6529 285.61 62.9446 283.908 62.9446 281.811V237.191C62.9446 235.092 64.6529 233.39 66.7617 233.39Z",
    fill: "url(#paint187_radial_3145_298)",
    fillOpacity: 0.2
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 257.672C84.4166 255.265 83.1305 253.522 81.6142 253.522C80.0997 253.522 78.8157 255.261 78.3743 257.662C78.2676 258.241 78.2095 258.857 78.2095 259.499C78.2095 260.141 78.2676 260.758 78.3743 261.338C78.8157 263.739 80.0979 265.475 81.6142 265.475C83.1305 265.475 84.4166 263.733 84.8563 261.328C84.9626 260.752 85.019 260.137 85.019 259.499C85.019 258.861 84.9626 258.248 84.8563 257.672Z",
    fill: "url(#paint188_radial_3145_298)",
    fillOpacity: 0.2
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 237.191V281.809C37.3392 283.908 35.6291 285.608 33.5221 285.608V233.39C35.6291 233.39 37.3392 235.092 37.3392 237.191Z",
    fill: "url(#paint189_radial_3145_298)",
    fillOpacity: 0.2
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 283.295V235.703C30.336 234.427 29.2943 233.39 28.0103 233.39H25.4944V254.783C26.3174 255.529 27.0149 256.319 27.5784 257.036C27.9638 257.527 28.2852 257.982 28.5388 258.366C28.6902 258.594 28.8179 258.796 28.9204 258.964C29.132 259.311 29.1324 259.687 28.9208 260.034C28.8183 260.202 28.6906 260.405 28.5388 260.634C28.2852 261.018 27.9638 261.473 27.5784 261.964C27.2318 262.405 26.8347 262.876 26.3874 263.344C26.1082 263.637 25.8102 263.93 25.4944 264.215V285.608H28.0103C29.2943 285.608 30.336 284.573 30.336 283.295Z",
    fill: "url(#paint190_radial_3145_298)",
    fillOpacity: 0.2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 252.462V233.39H21.9116V252.462C20.9162 252.058 19.8315 251.813 18.6696 251.813C17.5076 251.813 16.4251 252.058 15.4296 252.462Z",
    fill: "url(#paint191_radial_3145_298)",
    fillOpacity: 0.2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 266.538V285.608H15.4296V266.538C16.4251 266.942 17.5094 267.187 18.6696 267.187C19.8298 267.187 20.9141 266.942 21.9116 266.538Z",
    fill: "url(#paint192_radial_3145_298)",
    fillOpacity: 0.2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 233.39H9.32883C8.04691 233.39 7.00491 234.427 7.00491 235.703V283.295C7.00491 284.573 8.04691 285.608 9.32883 285.608H11.8465V264.219C11.0256 263.473 10.3264 262.683 9.76291 261.968C9.14694 261.182 8.6929 260.486 8.418 260.035C8.20673 259.687 8.20712 259.311 8.41873 258.964C8.69366 258.513 9.14731 257.817 9.76291 257.032C10.3264 256.315 11.0256 255.525 11.8465 254.781V233.39Z",
    fill: "url(#paint193_radial_3145_298)",
    fillOpacity: 0.2
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 233.39V285.61C1.70831 285.61 0 283.908 0 281.811V237.191C0 235.092 1.70831 233.39 3.81711 233.39Z",
    fill: "url(#paint194_radial_3145_298)",
    fillOpacity: 0.2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 257.672C21.472 255.265 20.1859 253.522 18.6696 253.522C17.155 253.522 15.871 255.261 15.4296 257.662C15.3229 258.241 15.2649 258.857 15.2649 259.499C15.2649 260.141 15.3229 260.758 15.4296 261.338C15.871 263.739 17.1533 265.475 18.6696 265.475C20.1859 265.475 21.472 263.733 21.9116 261.328C22.0179 260.752 22.0743 260.137 22.0743 259.499C22.0743 258.861 22.0179 258.248 21.9116 257.672Z",
    fill: "url(#paint195_radial_3145_298)",
    fillOpacity: 0.2
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M415 314.988V359.606C415 361.705 413.29 363.405 411.183 363.405V311.187C413.29 311.187 415 312.889 415 314.988Z",
    fill: "url(#paint196_radial_3145_298)",
    fillOpacity: 0.2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 361.092V313.5C407.997 312.224 406.955 311.187 405.671 311.187H403.155V332.58C403.978 333.325 404.676 334.116 405.239 334.833C405.625 335.324 405.946 335.779 406.2 336.162C406.351 336.391 406.479 336.593 406.581 336.761C406.793 337.108 406.793 337.484 406.582 337.831C406.479 337.999 406.351 338.202 406.2 338.431C405.946 338.815 405.625 339.269 405.239 339.761C404.893 340.202 404.496 340.672 404.048 341.141C403.769 341.434 403.471 341.726 403.155 342.012V363.405H405.671C406.955 363.405 407.997 362.37 407.997 361.092Z",
    fill: "url(#paint197_radial_3145_298)",
    fillOpacity: 0.2
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 330.259V311.187H399.572V330.259C398.577 329.855 397.492 329.61 396.33 329.61C395.168 329.61 394.086 329.855 393.09 330.259Z",
    fill: "url(#paint198_radial_3145_298)",
    fillOpacity: 0.2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 344.334V363.405H393.09V344.334C394.086 344.739 395.17 344.984 396.33 344.984C397.491 344.984 398.575 344.739 399.572 344.334Z",
    fill: "url(#paint199_radial_3145_298)",
    fillOpacity: 0.2
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 311.187H386.99C385.708 311.187 384.666 312.224 384.666 313.5V361.092C384.666 362.37 385.708 363.405 386.99 363.405H389.507V342.016C388.686 341.27 387.987 340.48 387.424 339.765C386.808 338.979 386.354 338.283 386.079 337.831C385.868 337.484 385.868 337.108 386.08 336.761C386.354 336.31 386.808 335.614 387.424 334.829C387.987 334.112 388.686 333.322 389.507 332.578V311.187Z",
    fill: "url(#paint200_radial_3145_298)",
    fillOpacity: 0.2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 311.187V363.407C379.369 363.407 377.661 361.705 377.661 359.608V314.988C377.661 312.889 379.369 311.187 381.478 311.187Z",
    fill: "url(#paint201_radial_3145_298)",
    fillOpacity: 0.2
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 335.469C399.133 333.062 397.847 331.319 396.33 331.319C394.816 331.319 393.532 333.058 393.09 335.459C392.984 336.037 392.926 336.654 392.926 337.296C392.926 337.938 392.984 338.554 393.09 339.134C393.532 341.536 394.814 343.272 396.33 343.272C397.847 343.272 399.133 341.53 399.572 339.125C399.679 338.549 399.735 337.934 399.735 337.296C399.735 336.658 399.679 336.045 399.572 335.469Z",
    fill: "url(#paint202_radial_3145_298)",
    fillOpacity: 0.2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 314.988V359.606C352.058 361.705 350.348 363.405 348.241 363.405V311.187C350.348 311.187 352.058 312.889 352.058 314.988Z",
    fill: "url(#paint203_radial_3145_298)",
    fillOpacity: 0.2
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 361.092V313.5C345.054 312.224 344.013 311.187 342.729 311.187H340.213V332.58C341.036 333.325 341.733 334.116 342.297 334.833C342.682 335.324 343.004 335.779 343.257 336.162C343.409 336.391 343.536 336.593 343.639 336.761C343.851 337.108 343.851 337.484 343.639 337.831C343.537 337.999 343.409 338.202 343.257 338.431C343.004 338.815 342.682 339.269 342.297 339.761C341.95 340.202 341.553 340.672 341.106 341.141C340.827 341.434 340.529 341.726 340.213 342.012V363.405H342.729C344.013 363.405 345.054 362.37 345.054 361.092Z",
    fill: "url(#paint204_radial_3145_298)",
    fillOpacity: 0.2
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 330.259V311.187H336.63V330.259C335.635 329.855 334.55 329.61 333.388 329.61C332.226 329.61 331.144 329.855 330.148 330.259Z",
    fill: "url(#paint205_radial_3145_298)",
    fillOpacity: 0.2
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 344.334V363.405H330.148V344.334C331.144 344.739 332.228 344.984 333.388 344.984C334.548 344.984 335.633 344.739 336.63 344.334Z",
    fill: "url(#paint206_radial_3145_298)",
    fillOpacity: 0.2
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 311.187H324.047C322.765 311.187 321.723 312.224 321.723 313.5V361.092C321.723 362.37 322.765 363.405 324.047 363.405H326.565V342.016C325.744 341.27 325.045 340.48 324.481 339.765C323.865 338.979 323.411 338.283 323.137 337.831C322.925 337.484 322.926 337.108 323.137 336.761C323.412 336.31 323.866 335.614 324.481 334.829C325.045 334.112 325.744 333.322 326.565 332.578V311.187Z",
    fill: "url(#paint207_radial_3145_298)",
    fillOpacity: 0.2
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 311.187V363.407C316.427 363.407 314.718 361.705 314.718 359.608V314.988C314.718 312.889 316.427 311.187 318.536 311.187Z",
    fill: "url(#paint208_radial_3145_298)",
    fillOpacity: 0.2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 335.469C336.19 333.062 334.904 331.319 333.388 331.319C331.874 331.319 330.59 333.058 330.148 335.459C330.041 336.037 329.983 336.654 329.983 337.296C329.983 337.938 330.041 338.554 330.148 339.134C330.59 341.536 331.872 343.272 333.388 343.272C334.904 343.272 336.19 341.53 336.63 339.125C336.736 338.549 336.793 337.934 336.793 337.296C336.793 336.658 336.736 336.045 336.63 335.469Z",
    fill: "url(#paint209_radial_3145_298)",
    fillOpacity: 0.2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 314.988V359.606C289.111 361.705 287.401 363.405 285.294 363.405V311.187C287.401 311.187 289.111 312.889 289.111 314.988Z",
    fill: "url(#paint210_radial_3145_298)",
    fillOpacity: 0.2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 361.092V313.5C282.108 312.224 281.066 311.187 279.782 311.187H277.266V332.58C278.089 333.325 278.786 334.116 279.35 334.833C279.735 335.324 280.057 335.779 280.31 336.162C280.462 336.391 280.59 336.593 280.692 336.761C280.904 337.108 280.904 337.484 280.692 337.831C280.59 337.999 280.462 338.202 280.31 338.431C280.057 338.815 279.735 339.269 279.35 339.761C279.003 340.202 278.606 340.672 278.159 341.141C277.88 341.434 277.582 341.726 277.266 342.012V363.405H279.782C281.066 363.405 282.108 362.37 282.108 361.092Z",
    fill: "url(#paint211_radial_3145_298)",
    fillOpacity: 0.2
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 330.259V311.187H273.683V330.259C272.688 329.855 271.603 329.61 270.441 329.61C269.279 329.61 268.197 329.855 267.201 330.259Z",
    fill: "url(#paint212_radial_3145_298)",
    fillOpacity: 0.2
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 344.334V363.405H267.201V344.334C268.197 344.739 269.281 344.984 270.441 344.984C271.601 344.984 272.686 344.739 273.683 344.334Z",
    fill: "url(#paint213_radial_3145_298)",
    fillOpacity: 0.2
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 311.187H261.1C259.818 311.187 258.776 312.224 258.776 313.5V361.092C258.776 362.37 259.818 363.405 261.1 363.405H263.618V342.016C262.797 341.27 262.098 340.48 261.534 339.765C260.919 338.979 260.464 338.283 260.19 337.831C259.978 337.484 259.979 337.108 260.19 336.761C260.465 336.31 260.919 335.614 261.534 334.829C262.098 334.112 262.797 333.322 263.618 332.578V311.187Z",
    fill: "url(#paint214_radial_3145_298)",
    fillOpacity: 0.2
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 311.187V363.407C253.48 363.407 251.772 361.705 251.772 359.608V314.988C251.772 312.889 253.48 311.187 255.589 311.187Z",
    fill: "url(#paint215_radial_3145_298)",
    fillOpacity: 0.2
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 335.469C273.244 333.062 271.957 331.319 270.441 331.319C268.927 331.319 267.643 333.058 267.201 335.459C267.094 336.037 267.036 336.654 267.036 337.296C267.036 337.938 267.094 338.554 267.201 339.134C267.643 341.536 268.925 343.272 270.441 343.272C271.957 343.272 273.244 341.53 273.683 339.125C273.79 338.549 273.846 337.934 273.846 337.296C273.846 336.658 273.79 336.045 273.683 335.469Z",
    fill: "url(#paint216_radial_3145_298)",
    fillOpacity: 0.2
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 314.988V359.606C226.173 361.705 224.463 363.405 222.356 363.405V311.187C224.463 311.187 226.173 312.889 226.173 314.988Z",
    fill: "url(#paint217_radial_3145_298)",
    fillOpacity: 0.2
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 361.092V313.5C219.17 312.224 218.128 311.187 216.844 311.187H214.328V332.58C215.151 333.325 215.849 334.116 216.412 334.833C216.798 335.324 217.119 335.779 217.373 336.162C217.524 336.391 217.652 336.593 217.754 336.761C217.966 337.108 217.966 337.484 217.755 337.831C217.652 337.999 217.525 338.202 217.373 338.431C217.119 338.815 216.798 339.269 216.412 339.761C216.066 340.202 215.669 340.672 215.221 341.141C214.942 341.434 214.644 341.726 214.328 342.012V363.405H216.844C218.128 363.405 219.17 362.37 219.17 361.092Z",
    fill: "url(#paint218_radial_3145_298)",
    fillOpacity: 0.2
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 330.259V311.187H210.746V330.259C209.75 329.855 208.665 329.61 207.503 329.61C206.342 329.61 205.259 329.855 204.263 330.259Z",
    fill: "url(#paint219_radial_3145_298)",
    fillOpacity: 0.2
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 344.334V363.405H204.263V344.334C205.259 344.739 206.343 344.984 207.503 344.984C208.664 344.984 209.748 344.739 210.746 344.334Z",
    fill: "url(#paint220_radial_3145_298)",
    fillOpacity: 0.2
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 311.187H198.163C196.881 311.187 195.839 312.224 195.839 313.5V361.092C195.839 362.37 196.881 363.405 198.163 363.405H200.68V342.016C199.859 341.27 199.16 340.48 198.597 339.765C197.981 338.979 197.527 338.283 197.252 337.831C197.041 337.484 197.041 337.108 197.253 336.761C197.528 336.31 197.981 335.614 198.597 334.829C199.16 334.112 199.859 333.322 200.68 332.578V311.187Z",
    fill: "url(#paint221_radial_3145_298)",
    fillOpacity: 0.2
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 311.187V363.407C190.542 363.407 188.834 361.705 188.834 359.608V314.988C188.834 312.889 190.542 311.187 192.651 311.187Z",
    fill: "url(#paint222_radial_3145_298)",
    fillOpacity: 0.2
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 335.469C210.306 333.062 209.02 331.319 207.503 331.319C205.989 331.319 204.705 333.058 204.263 335.459C204.157 336.037 204.099 336.654 204.099 337.296C204.099 337.938 204.157 338.554 204.263 339.134C204.705 341.536 205.987 343.272 207.503 343.272C209.02 343.272 210.306 341.53 210.746 339.125C210.852 338.549 210.908 337.934 210.908 337.296C210.908 336.658 210.852 336.045 210.746 335.469Z",
    fill: "url(#paint223_radial_3145_298)",
    fillOpacity: 0.2
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 314.988V359.606C163.226 361.705 161.516 363.405 159.409 363.405V311.187C161.516 311.187 163.226 312.889 163.226 314.988Z",
    fill: "url(#paint224_radial_3145_298)",
    fillOpacity: 0.2
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 361.092V313.5C156.223 312.224 155.181 311.187 153.897 311.187H151.381V332.58C152.204 333.325 152.902 334.116 153.465 334.833C153.851 335.324 154.172 335.779 154.426 336.162C154.577 336.391 154.705 336.593 154.807 336.761C155.019 337.108 155.019 337.484 154.808 337.831C154.705 337.999 154.578 338.202 154.426 338.431C154.172 338.815 153.851 339.269 153.465 339.761C153.119 340.202 152.722 340.672 152.274 341.141C151.995 341.434 151.697 341.726 151.381 342.012V363.405H153.897C155.181 363.405 156.223 362.37 156.223 361.092Z",
    fill: "url(#paint225_radial_3145_298)",
    fillOpacity: 0.2
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 330.259V311.187H147.799V330.259C146.803 329.855 145.718 329.61 144.556 329.61C143.395 329.61 142.312 329.855 141.317 330.259Z",
    fill: "url(#paint226_radial_3145_298)",
    fillOpacity: 0.2
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 344.334V363.405H141.317V344.334C142.312 344.739 143.396 344.984 144.556 344.984C145.717 344.984 146.801 344.739 147.799 344.334Z",
    fill: "url(#paint227_radial_3145_298)",
    fillOpacity: 0.2
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 311.187H135.216C133.934 311.187 132.892 312.224 132.892 313.5V361.092C132.892 362.37 133.934 363.405 135.216 363.405H137.733V342.016C136.913 341.27 136.213 340.48 135.65 339.765C135.034 338.979 134.58 338.283 134.305 337.831C134.094 337.484 134.094 337.108 134.306 336.761C134.581 336.31 135.034 335.614 135.65 334.829C136.213 334.112 136.913 333.322 137.733 332.578V311.187Z",
    fill: "url(#paint228_radial_3145_298)",
    fillOpacity: 0.2
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 311.187V363.407C127.595 363.407 125.887 361.705 125.887 359.608V314.988C125.887 312.889 127.595 311.187 129.704 311.187Z",
    fill: "url(#paint229_radial_3145_298)",
    fillOpacity: 0.2
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 335.469C147.359 333.062 146.073 331.319 144.556 331.319C143.042 331.319 141.758 333.058 141.317 335.459C141.21 336.037 141.152 336.654 141.152 337.296C141.152 337.938 141.21 338.554 141.317 339.134C141.758 341.536 143.04 343.272 144.556 343.272C146.073 343.272 147.359 341.53 147.799 339.125C147.905 338.549 147.961 337.934 147.961 337.296C147.961 336.658 147.905 336.045 147.799 335.469Z",
    fill: "url(#paint230_radial_3145_298)",
    fillOpacity: 0.2
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 314.988V359.606C100.284 361.705 98.5738 363.405 96.4667 363.405V311.187C98.5738 311.187 100.284 312.889 100.284 314.988Z",
    fill: "url(#paint231_radial_3145_298)",
    fillOpacity: 0.2
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 361.092V313.5C93.2806 312.224 92.239 311.187 90.955 311.187H88.439V332.58C89.2621 333.325 89.9595 334.116 90.523 334.833C90.9084 335.324 91.2299 335.779 91.4834 336.162C91.6349 336.391 91.7626 336.593 91.8651 336.761C92.0767 337.108 92.077 337.484 91.8654 337.831C91.7629 337.999 91.6352 338.202 91.4834 338.431C91.2299 338.815 90.9084 339.269 90.523 339.761C90.1764 340.202 89.7794 340.672 89.332 341.141C89.0529 341.434 88.7549 341.726 88.439 342.012V363.405H90.955C92.239 363.405 93.2806 362.37 93.2806 361.092Z",
    fill: "url(#paint232_radial_3145_298)",
    fillOpacity: 0.2
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 330.259V311.187H84.8563V330.259C83.8608 329.855 82.7762 329.61 81.6142 329.61C80.4522 329.61 79.3697 329.855 78.3743 330.259Z",
    fill: "url(#paint233_radial_3145_298)",
    fillOpacity: 0.2
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 344.334V363.405H78.3743V344.334C79.3697 344.739 80.454 344.984 81.6142 344.984C82.7744 344.984 83.8587 344.739 84.8563 344.334Z",
    fill: "url(#paint234_radial_3145_298)",
    fillOpacity: 0.2
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 311.187H72.2735C70.9915 311.187 69.9496 312.224 69.9496 313.5V361.092C69.9496 362.37 70.9915 363.405 72.2735 363.405H74.7912V342.016C73.9702 341.27 73.271 340.48 72.7075 339.765C72.0916 338.979 71.6376 338.283 71.3626 337.831C71.1514 337.484 71.1517 337.108 71.3634 336.761C71.6383 336.31 72.0919 335.614 72.7075 334.829C73.271 334.112 73.9702 333.322 74.7912 332.578V311.187Z",
    fill: "url(#paint235_radial_3145_298)",
    fillOpacity: 0.2
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 311.187V363.407C64.6529 363.407 62.9446 361.705 62.9446 359.608V314.988C62.9446 312.889 64.6529 311.187 66.7617 311.187Z",
    fill: "url(#paint236_radial_3145_298)",
    fillOpacity: 0.2
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 335.469C84.4166 333.062 83.1305 331.319 81.6142 331.319C80.0997 331.319 78.8157 333.058 78.3743 335.459C78.2676 336.037 78.2095 336.654 78.2095 337.296C78.2095 337.938 78.2676 338.554 78.3743 339.134C78.8157 341.536 80.0979 343.272 81.6142 343.272C83.1305 343.272 84.4166 341.53 84.8563 339.125C84.9626 338.549 85.019 337.934 85.019 337.296C85.019 336.658 84.9626 336.045 84.8563 335.469Z",
    fill: "url(#paint237_radial_3145_298)",
    fillOpacity: 0.2
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 314.988V359.606C37.3392 361.705 35.6291 363.405 33.5221 363.405V311.187C35.6291 311.187 37.3392 312.889 37.3392 314.988Z",
    fill: "url(#paint238_radial_3145_298)",
    fillOpacity: 0.2
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 361.092V313.5C30.336 312.224 29.2943 311.187 28.0103 311.187H25.4944V332.58C26.3174 333.325 27.0149 334.116 27.5784 334.833C27.9638 335.324 28.2852 335.779 28.5388 336.162C28.6902 336.391 28.8179 336.593 28.9204 336.761C29.132 337.108 29.1324 337.484 28.9208 337.831C28.8183 337.999 28.6906 338.202 28.5388 338.431C28.2852 338.815 27.9638 339.269 27.5784 339.761C27.2318 340.202 26.8347 340.672 26.3874 341.141C26.1082 341.434 25.8102 341.726 25.4944 342.012V363.405H28.0103C29.2943 363.405 30.336 362.37 30.336 361.092Z",
    fill: "url(#paint239_radial_3145_298)",
    fillOpacity: 0.2
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 330.259V311.187H21.9116V330.259C20.9162 329.855 19.8315 329.61 18.6696 329.61C17.5076 329.61 16.4251 329.855 15.4296 330.259Z",
    fill: "url(#paint240_radial_3145_298)",
    fillOpacity: 0.2
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 344.334V363.405H15.4296V344.334C16.4251 344.739 17.5094 344.984 18.6696 344.984C19.8298 344.984 20.9141 344.739 21.9116 344.334Z",
    fill: "url(#paint241_radial_3145_298)",
    fillOpacity: 0.2
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 311.187H9.32883C8.04691 311.187 7.00491 312.224 7.00491 313.5V361.092C7.00491 362.37 8.04691 363.405 9.32883 363.405H11.8465V342.016C11.0256 341.27 10.3264 340.48 9.76291 339.765C9.14694 338.979 8.6929 338.283 8.418 337.831C8.20673 337.484 8.20712 337.108 8.41873 336.761C8.69366 336.31 9.14731 335.614 9.76291 334.829C10.3264 334.112 11.0256 333.322 11.8465 332.578V311.187Z",
    fill: "url(#paint242_radial_3145_298)",
    fillOpacity: 0.2
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 311.187V363.407C1.70831 363.407 0 361.705 0 359.608V314.988C0 312.889 1.70831 311.187 3.81711 311.187Z",
    fill: "url(#paint243_radial_3145_298)",
    fillOpacity: 0.2
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 335.469C21.472 333.062 20.1859 331.319 18.6696 331.319C17.155 331.319 15.871 333.058 15.4296 335.459C15.3229 336.037 15.2649 336.654 15.2649 337.296C15.2649 337.938 15.3229 338.554 15.4296 339.134C15.871 341.536 17.1533 343.272 18.6696 343.272C20.1859 343.272 21.472 341.53 21.9116 339.125C22.0179 338.549 22.0743 337.934 22.0743 337.296C22.0743 336.658 22.0179 336.045 21.9116 335.469Z",
    fill: "url(#paint244_radial_3145_298)",
    fillOpacity: 0.2
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M415 392.784V437.402C415 439.501 413.29 441.201 411.183 441.201V388.983C413.29 388.983 415 390.685 415 392.784Z",
    fill: "url(#paint245_radial_3145_298)",
    fillOpacity: 0.2
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 438.889V391.296C407.997 390.021 406.955 388.983 405.671 388.983H403.155V410.376C403.978 411.122 404.676 411.912 405.239 412.629C405.625 413.121 405.946 413.576 406.2 413.959C406.351 414.187 406.479 414.389 406.581 414.558C406.793 414.904 406.793 415.281 406.582 415.628C406.479 415.796 406.351 415.999 406.2 416.228C405.946 416.611 405.625 417.066 405.239 417.557C404.893 417.999 404.496 418.469 404.048 418.937C403.769 419.23 403.471 419.523 403.155 419.808V441.201H405.671C406.955 441.201 407.997 440.166 407.997 438.889Z",
    fill: "url(#paint246_radial_3145_298)",
    fillOpacity: 0.2
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 408.056V388.983H399.572V408.056C398.577 407.651 397.492 407.406 396.33 407.406C395.168 407.406 394.086 407.651 393.09 408.056Z",
    fill: "url(#paint247_radial_3145_298)",
    fillOpacity: 0.2
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 422.131V441.201H393.09V422.131C394.086 422.535 395.17 422.78 396.33 422.78C397.491 422.78 398.575 422.535 399.572 422.131Z",
    fill: "url(#paint248_radial_3145_298)",
    fillOpacity: 0.2
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 388.983H386.99C385.708 388.983 384.666 390.021 384.666 391.296V438.889C384.666 440.166 385.708 441.201 386.99 441.201H389.507V419.812C388.686 419.066 387.987 418.276 387.424 417.561C386.808 416.776 386.354 416.079 386.079 415.628C385.868 415.281 385.868 414.904 386.08 414.557C386.354 414.107 386.808 413.41 387.424 412.625C387.987 411.908 388.686 411.118 389.507 410.375V388.983Z",
    fill: "url(#paint249_radial_3145_298)",
    fillOpacity: 0.2
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 388.983V441.203C379.369 441.203 377.661 439.501 377.661 437.405V392.784C377.661 390.685 379.369 388.983 381.478 388.983Z",
    fill: "url(#paint250_radial_3145_298)",
    fillOpacity: 0.2
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 413.265C399.133 410.858 397.847 409.116 396.33 409.116C394.816 409.116 393.532 410.854 393.09 413.256C392.984 413.834 392.926 414.451 392.926 415.092C392.926 415.734 392.984 416.351 393.09 416.931C393.532 419.332 394.814 421.069 396.33 421.069C397.847 421.069 399.133 419.327 399.572 416.922C399.679 416.345 399.735 415.73 399.735 415.092C399.735 414.455 399.679 413.842 399.572 413.265Z",
    fill: "url(#paint251_radial_3145_298)",
    fillOpacity: 0.2
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 392.784V437.402C352.058 439.501 350.348 441.201 348.241 441.201V388.983C350.348 388.983 352.058 390.685 352.058 392.784Z",
    fill: "url(#paint252_radial_3145_298)",
    fillOpacity: 0.2
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 438.889V391.296C345.054 390.021 344.013 388.983 342.729 388.983H340.213V410.376C341.036 411.122 341.733 411.912 342.297 412.629C342.682 413.121 343.004 413.576 343.257 413.959C343.409 414.187 343.536 414.389 343.639 414.558C343.851 414.904 343.851 415.281 343.639 415.628C343.537 415.796 343.409 415.999 343.257 416.228C343.004 416.611 342.682 417.066 342.297 417.557C341.95 417.999 341.553 418.469 341.106 418.937C340.827 419.23 340.529 419.523 340.213 419.808V441.201H342.729C344.013 441.201 345.054 440.166 345.054 438.889Z",
    fill: "url(#paint253_radial_3145_298)",
    fillOpacity: 0.2
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 408.056V388.983H336.63V408.056C335.635 407.651 334.55 407.406 333.388 407.406C332.226 407.406 331.144 407.651 330.148 408.056Z",
    fill: "url(#paint254_radial_3145_298)",
    fillOpacity: 0.2
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 422.131V441.201H330.148V422.131C331.144 422.535 332.228 422.78 333.388 422.78C334.548 422.78 335.633 422.535 336.63 422.131Z",
    fill: "url(#paint255_radial_3145_298)",
    fillOpacity: 0.2
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 388.983H324.047C322.765 388.983 321.723 390.021 321.723 391.296V438.889C321.723 440.166 322.765 441.201 324.047 441.201H326.565V419.812C325.744 419.066 325.045 418.276 324.481 417.561C323.865 416.776 323.411 416.079 323.137 415.628C322.925 415.281 322.926 414.904 323.137 414.557C323.412 414.107 323.866 413.41 324.481 412.625C325.045 411.908 325.744 411.118 326.565 410.375V388.983Z",
    fill: "url(#paint256_radial_3145_298)",
    fillOpacity: 0.2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 388.983V441.203C316.427 441.203 314.718 439.501 314.718 437.405V392.784C314.718 390.685 316.427 388.983 318.536 388.983Z",
    fill: "url(#paint257_radial_3145_298)",
    fillOpacity: 0.2
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 413.265C336.19 410.858 334.904 409.116 333.388 409.116C331.874 409.116 330.59 410.854 330.148 413.256C330.041 413.834 329.983 414.451 329.983 415.092C329.983 415.734 330.041 416.351 330.148 416.931C330.59 419.332 331.872 421.069 333.388 421.069C334.904 421.069 336.19 419.327 336.63 416.922C336.736 416.345 336.793 415.73 336.793 415.092C336.793 414.455 336.736 413.842 336.63 413.265Z",
    fill: "url(#paint258_radial_3145_298)",
    fillOpacity: 0.2
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 392.784V437.402C289.111 439.501 287.401 441.201 285.294 441.201V388.983C287.401 388.983 289.111 390.685 289.111 392.784Z",
    fill: "url(#paint259_radial_3145_298)",
    fillOpacity: 0.2
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 438.889V391.296C282.108 390.021 281.066 388.983 279.782 388.983H277.266V410.376C278.089 411.122 278.786 411.912 279.35 412.629C279.735 413.121 280.057 413.576 280.31 413.959C280.462 414.187 280.59 414.389 280.692 414.558C280.904 414.904 280.904 415.281 280.692 415.628C280.59 415.796 280.462 415.999 280.31 416.228C280.057 416.611 279.735 417.066 279.35 417.557C279.003 417.999 278.606 418.469 278.159 418.937C277.88 419.23 277.582 419.523 277.266 419.808V441.201H279.782C281.066 441.201 282.108 440.166 282.108 438.889Z",
    fill: "url(#paint260_radial_3145_298)",
    fillOpacity: 0.2
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 408.056V388.983H273.683V408.056C272.688 407.651 271.603 407.406 270.441 407.406C269.279 407.406 268.197 407.651 267.201 408.056Z",
    fill: "url(#paint261_radial_3145_298)",
    fillOpacity: 0.2
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 422.131V441.201H267.201V422.131C268.197 422.535 269.281 422.78 270.441 422.78C271.601 422.78 272.686 422.535 273.683 422.131Z",
    fill: "url(#paint262_radial_3145_298)",
    fillOpacity: 0.2
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 388.983H261.1C259.818 388.983 258.776 390.021 258.776 391.296V438.889C258.776 440.166 259.818 441.201 261.1 441.201H263.618V419.812C262.797 419.066 262.098 418.276 261.534 417.561C260.919 416.776 260.464 416.079 260.19 415.628C259.978 415.281 259.979 414.904 260.19 414.557C260.465 414.107 260.919 413.41 261.534 412.625C262.098 411.908 262.797 411.118 263.618 410.375V388.983Z",
    fill: "url(#paint263_radial_3145_298)",
    fillOpacity: 0.2
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 388.983V441.203C253.48 441.203 251.772 439.501 251.772 437.405V392.784C251.772 390.685 253.48 388.983 255.589 388.983Z",
    fill: "url(#paint264_radial_3145_298)",
    fillOpacity: 0.2
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 413.265C273.244 410.858 271.957 409.116 270.441 409.116C268.927 409.116 267.643 410.854 267.201 413.256C267.094 413.834 267.036 414.451 267.036 415.092C267.036 415.734 267.094 416.351 267.201 416.931C267.643 419.332 268.925 421.069 270.441 421.069C271.957 421.069 273.244 419.327 273.683 416.922C273.79 416.345 273.846 415.73 273.846 415.092C273.846 414.455 273.79 413.842 273.683 413.265Z",
    fill: "url(#paint265_radial_3145_298)",
    fillOpacity: 0.2
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 392.784V437.402C226.173 439.501 224.463 441.201 222.356 441.201V388.983C224.463 388.983 226.173 390.685 226.173 392.784Z",
    fill: "url(#paint266_radial_3145_298)",
    fillOpacity: 0.2
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 438.889V391.296C219.17 390.021 218.128 388.983 216.844 388.983H214.328V410.376C215.151 411.122 215.849 411.912 216.412 412.629C216.798 413.121 217.119 413.576 217.373 413.959C217.524 414.187 217.652 414.389 217.754 414.558C217.966 414.904 217.966 415.281 217.755 415.628C217.652 415.796 217.525 415.999 217.373 416.228C217.119 416.611 216.798 417.066 216.412 417.557C216.066 417.999 215.669 418.469 215.221 418.937C214.942 419.23 214.644 419.523 214.328 419.808V441.201H216.844C218.128 441.201 219.17 440.166 219.17 438.889Z",
    fill: "url(#paint267_radial_3145_298)",
    fillOpacity: 0.2
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 408.056V388.983H210.746V408.056C209.75 407.651 208.665 407.406 207.503 407.406C206.342 407.406 205.259 407.651 204.263 408.056Z",
    fill: "url(#paint268_radial_3145_298)",
    fillOpacity: 0.2
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 422.131V441.201H204.263V422.131C205.259 422.535 206.343 422.78 207.503 422.78C208.664 422.78 209.748 422.535 210.746 422.131Z",
    fill: "url(#paint269_radial_3145_298)",
    fillOpacity: 0.2
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 388.983H198.163C196.881 388.983 195.839 390.021 195.839 391.296V438.889C195.839 440.166 196.881 441.201 198.163 441.201H200.68V419.812C199.859 419.066 199.16 418.276 198.597 417.561C197.981 416.776 197.527 416.079 197.252 415.628C197.041 415.281 197.041 414.904 197.253 414.557C197.528 414.107 197.981 413.41 198.597 412.625C199.16 411.908 199.859 411.118 200.68 410.375V388.983Z",
    fill: "url(#paint270_radial_3145_298)",
    fillOpacity: 0.2
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 388.983V441.203C190.542 441.203 188.834 439.501 188.834 437.405V392.784C188.834 390.685 190.542 388.983 192.651 388.983Z",
    fill: "url(#paint271_radial_3145_298)",
    fillOpacity: 0.2
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 413.265C210.306 410.858 209.02 409.116 207.503 409.116C205.989 409.116 204.705 410.854 204.263 413.256C204.157 413.834 204.099 414.451 204.099 415.092C204.099 415.734 204.157 416.351 204.263 416.931C204.705 419.332 205.987 421.069 207.503 421.069C209.02 421.069 210.306 419.327 210.746 416.922C210.852 416.345 210.908 415.73 210.908 415.092C210.908 414.455 210.852 413.842 210.746 413.265Z",
    fill: "url(#paint272_radial_3145_298)",
    fillOpacity: 0.2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 392.784V437.402C163.226 439.501 161.516 441.201 159.409 441.201V388.983C161.516 388.983 163.226 390.685 163.226 392.784Z",
    fill: "url(#paint273_radial_3145_298)",
    fillOpacity: 0.2
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 438.889V391.296C156.223 390.021 155.181 388.983 153.897 388.983H151.381V410.376C152.204 411.122 152.902 411.912 153.465 412.629C153.851 413.121 154.172 413.576 154.426 413.959C154.577 414.187 154.705 414.389 154.807 414.558C155.019 414.904 155.019 415.281 154.808 415.628C154.705 415.796 154.578 415.999 154.426 416.228C154.172 416.611 153.851 417.066 153.465 417.557C153.119 417.999 152.722 418.469 152.274 418.937C151.995 419.23 151.697 419.523 151.381 419.808V441.201H153.897C155.181 441.201 156.223 440.166 156.223 438.889Z",
    fill: "url(#paint274_radial_3145_298)",
    fillOpacity: 0.2
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 408.056V388.983H147.799V408.056C146.803 407.651 145.718 407.406 144.556 407.406C143.395 407.406 142.312 407.651 141.317 408.056Z",
    fill: "url(#paint275_radial_3145_298)",
    fillOpacity: 0.2
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 422.131V441.201H141.317V422.131C142.312 422.535 143.396 422.78 144.556 422.78C145.717 422.78 146.801 422.535 147.799 422.131Z",
    fill: "url(#paint276_radial_3145_298)",
    fillOpacity: 0.2
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 388.983H135.216C133.934 388.983 132.892 390.021 132.892 391.296V438.889C132.892 440.166 133.934 441.201 135.216 441.201H137.733V419.812C136.913 419.066 136.213 418.276 135.65 417.561C135.034 416.776 134.58 416.079 134.305 415.628C134.094 415.281 134.094 414.904 134.306 414.557C134.581 414.107 135.034 413.41 135.65 412.625C136.213 411.908 136.913 411.118 137.733 410.375V388.983Z",
    fill: "url(#paint277_radial_3145_298)",
    fillOpacity: 0.2
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 388.983V441.203C127.595 441.203 125.887 439.501 125.887 437.405V392.784C125.887 390.685 127.595 388.983 129.704 388.983Z",
    fill: "url(#paint278_radial_3145_298)",
    fillOpacity: 0.2
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 413.265C147.359 410.858 146.073 409.116 144.556 409.116C143.042 409.116 141.758 410.854 141.317 413.256C141.21 413.834 141.152 414.451 141.152 415.092C141.152 415.734 141.21 416.351 141.317 416.931C141.758 419.332 143.04 421.069 144.556 421.069C146.073 421.069 147.359 419.327 147.799 416.922C147.905 416.345 147.961 415.73 147.961 415.092C147.961 414.455 147.905 413.842 147.799 413.265Z",
    fill: "url(#paint279_radial_3145_298)",
    fillOpacity: 0.2
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 392.784V437.402C100.284 439.501 98.5738 441.201 96.4667 441.201V388.983C98.5738 388.983 100.284 390.685 100.284 392.784Z",
    fill: "url(#paint280_radial_3145_298)",
    fillOpacity: 0.2
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 438.889V391.296C93.2806 390.021 92.239 388.983 90.955 388.983H88.439V410.376C89.2621 411.122 89.9595 411.912 90.523 412.629C90.9084 413.121 91.2299 413.576 91.4834 413.959C91.6349 414.187 91.7626 414.389 91.8651 414.558C92.0767 414.904 92.077 415.281 91.8654 415.628C91.7629 415.796 91.6352 415.999 91.4834 416.228C91.2299 416.611 90.9084 417.066 90.523 417.557C90.1764 417.999 89.7794 418.469 89.332 418.937C89.0529 419.23 88.7549 419.523 88.439 419.808V441.201H90.955C92.239 441.201 93.2806 440.166 93.2806 438.889Z",
    fill: "url(#paint281_radial_3145_298)",
    fillOpacity: 0.2
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 408.056V388.983H84.8563V408.056C83.8608 407.651 82.7762 407.406 81.6142 407.406C80.4522 407.406 79.3697 407.651 78.3743 408.056Z",
    fill: "url(#paint282_radial_3145_298)",
    fillOpacity: 0.2
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 422.131V441.201H78.3743V422.131C79.3697 422.535 80.454 422.78 81.6142 422.78C82.7744 422.78 83.8587 422.535 84.8563 422.131Z",
    fill: "url(#paint283_radial_3145_298)",
    fillOpacity: 0.2
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 388.983H72.2735C70.9915 388.983 69.9496 390.021 69.9496 391.296V438.889C69.9496 440.166 70.9915 441.201 72.2735 441.201H74.7912V419.812C73.9702 419.066 73.271 418.276 72.7075 417.561C72.0916 416.776 71.6376 416.079 71.3626 415.628C71.1514 415.281 71.1517 414.904 71.3634 414.557C71.6383 414.107 72.0919 413.41 72.7075 412.625C73.271 411.908 73.9702 411.118 74.7912 410.375V388.983Z",
    fill: "url(#paint284_radial_3145_298)",
    fillOpacity: 0.2
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 388.983V441.203C64.6529 441.203 62.9446 439.501 62.9446 437.405V392.784C62.9446 390.685 64.6529 388.983 66.7617 388.983Z",
    fill: "url(#paint285_radial_3145_298)",
    fillOpacity: 0.2
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 413.265C84.4166 410.858 83.1305 409.116 81.6142 409.116C80.0997 409.116 78.8157 410.854 78.3743 413.256C78.2676 413.834 78.2095 414.451 78.2095 415.092C78.2095 415.734 78.2676 416.351 78.3743 416.931C78.8157 419.332 80.0979 421.069 81.6142 421.069C83.1305 421.069 84.4166 419.327 84.8563 416.922C84.9626 416.345 85.019 415.73 85.019 415.092C85.019 414.455 84.9626 413.842 84.8563 413.265Z",
    fill: "url(#paint286_radial_3145_298)",
    fillOpacity: 0.2
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 392.784V437.402C37.3392 439.501 35.6291 441.201 33.5221 441.201V388.983C35.6291 388.983 37.3392 390.685 37.3392 392.784Z",
    fill: "url(#paint287_radial_3145_298)",
    fillOpacity: 0.2
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 438.889V391.296C30.336 390.021 29.2943 388.983 28.0103 388.983H25.4944V410.376C26.3174 411.122 27.0149 411.912 27.5784 412.629C27.9638 413.121 28.2852 413.576 28.5388 413.959C28.6902 414.187 28.8179 414.389 28.9204 414.558C29.132 414.904 29.1324 415.281 28.9208 415.628C28.8183 415.796 28.6906 415.999 28.5388 416.228C28.2852 416.611 27.9638 417.066 27.5784 417.557C27.2318 417.999 26.8347 418.469 26.3874 418.937C26.1082 419.23 25.8102 419.523 25.4944 419.808V441.201H28.0103C29.2943 441.201 30.336 440.166 30.336 438.889Z",
    fill: "url(#paint288_radial_3145_298)",
    fillOpacity: 0.2
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 408.056V388.983H21.9116V408.056C20.9162 407.651 19.8315 407.406 18.6696 407.406C17.5076 407.406 16.4251 407.651 15.4296 408.056Z",
    fill: "url(#paint289_radial_3145_298)",
    fillOpacity: 0.2
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 422.131V441.201H15.4296V422.131C16.4251 422.535 17.5094 422.78 18.6696 422.78C19.8298 422.78 20.9141 422.535 21.9116 422.131Z",
    fill: "url(#paint290_radial_3145_298)",
    fillOpacity: 0.2
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 388.983H9.32883C8.04691 388.983 7.00491 390.021 7.00491 391.296V438.889C7.00491 440.166 8.04691 441.201 9.32883 441.201H11.8465V419.812C11.0256 419.066 10.3264 418.276 9.76291 417.561C9.14694 416.776 8.6929 416.079 8.418 415.628C8.20673 415.281 8.20712 414.904 8.41873 414.557C8.69366 414.107 9.14731 413.41 9.76291 412.625C10.3264 411.908 11.0256 411.118 11.8465 410.375V388.983Z",
    fill: "url(#paint291_radial_3145_298)",
    fillOpacity: 0.2
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 388.983V441.203C1.70831 441.203 0 439.501 0 437.405V392.784C0 390.685 1.70831 388.983 3.81711 388.983Z",
    fill: "url(#paint292_radial_3145_298)",
    fillOpacity: 0.2
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 413.265C21.472 410.858 20.1859 409.116 18.6696 409.116C17.155 409.116 15.871 410.854 15.4296 413.256C15.3229 413.834 15.2649 414.451 15.2649 415.092C15.2649 415.734 15.3229 416.351 15.4296 416.931C15.871 419.332 17.1533 421.069 18.6696 421.069C20.1859 421.069 21.472 419.327 21.9116 416.922C22.0179 416.345 22.0743 415.73 22.0743 415.092C22.0743 414.455 22.0179 413.842 21.9116 413.265Z",
    fill: "url(#paint293_radial_3145_298)",
    fillOpacity: 0.2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M415 470.581V515.199C415 517.298 413.29 518.998 411.183 518.998V466.78C413.29 466.78 415 468.482 415 470.581Z",
    fill: "url(#paint294_radial_3145_298)",
    fillOpacity: 0.2
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M407.997 516.685V469.093C407.997 467.817 406.955 466.78 405.671 466.78H403.155V488.173C403.978 488.919 404.676 489.709 405.239 490.426C405.625 490.918 405.946 491.372 406.2 491.756C406.351 491.984 406.479 492.186 406.581 492.354C406.793 492.701 406.793 493.077 406.582 493.424C406.479 493.592 406.351 493.795 406.2 494.024C405.946 494.408 405.625 494.863 405.239 495.354C404.893 495.795 404.496 496.266 404.048 496.734C403.769 497.027 403.471 497.32 403.155 497.605V518.998H405.671C406.955 518.998 407.997 517.963 407.997 516.685Z",
    fill: "url(#paint295_radial_3145_298)",
    fillOpacity: 0.2
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M393.09 485.853V466.78H399.572V485.853C398.577 485.448 397.492 485.203 396.33 485.203C395.168 485.203 394.086 485.448 393.09 485.853Z",
    fill: "url(#paint296_radial_3145_298)",
    fillOpacity: 0.2
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 499.928V518.998H393.09V499.928C394.086 500.332 395.17 500.577 396.33 500.577C397.491 500.577 398.575 500.332 399.572 499.928Z",
    fill: "url(#paint297_radial_3145_298)",
    fillOpacity: 0.2
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M389.507 466.78H386.99C385.708 466.78 384.666 467.817 384.666 469.093V516.685C384.666 517.963 385.708 518.998 386.99 518.998H389.507V497.609C388.686 496.863 387.987 496.073 387.424 495.358C386.808 494.572 386.354 493.876 386.079 493.425C385.868 493.077 385.868 492.701 386.08 492.354C386.354 491.903 386.808 491.207 387.424 490.422C387.987 489.705 388.686 488.915 389.507 488.171V466.78Z",
    fill: "url(#paint298_radial_3145_298)",
    fillOpacity: 0.2
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M381.478 466.78V519C379.369 519 377.661 517.298 377.661 515.201V470.581C377.661 468.482 379.369 466.78 381.478 466.78Z",
    fill: "url(#paint299_radial_3145_298)",
    fillOpacity: 0.2
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M399.572 491.062C399.133 488.655 397.847 486.913 396.33 486.913C394.816 486.913 393.532 488.651 393.09 491.053C392.984 491.631 392.926 492.247 392.926 492.889C392.926 493.531 392.984 494.148 393.09 494.728C393.532 497.129 394.814 498.866 396.33 498.866C397.847 498.866 399.133 497.124 399.572 494.718C399.679 494.142 399.735 493.527 399.735 492.889C399.735 492.251 399.679 491.638 399.572 491.062Z",
    fill: "url(#paint300_radial_3145_298)",
    fillOpacity: 0.2
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 470.581V515.199C352.058 517.298 350.348 518.998 348.241 518.998V466.78C350.348 466.78 352.058 468.482 352.058 470.581Z",
    fill: "url(#paint301_radial_3145_298)",
    fillOpacity: 0.2
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M345.054 516.685V469.093C345.054 467.817 344.013 466.78 342.729 466.78H340.213V488.173C341.036 488.919 341.733 489.709 342.297 490.426C342.682 490.918 343.004 491.372 343.257 491.756C343.409 491.984 343.536 492.186 343.639 492.354C343.851 492.701 343.851 493.077 343.639 493.424C343.537 493.592 343.409 493.795 343.257 494.024C343.004 494.408 342.682 494.863 342.297 495.354C341.95 495.795 341.553 496.266 341.106 496.734C340.827 497.027 340.529 497.32 340.213 497.605V518.998H342.729C344.013 518.998 345.054 517.963 345.054 516.685Z",
    fill: "url(#paint302_radial_3145_298)",
    fillOpacity: 0.2
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M330.148 485.853V466.78H336.63V485.853C335.635 485.448 334.55 485.203 333.388 485.203C332.226 485.203 331.144 485.448 330.148 485.853Z",
    fill: "url(#paint303_radial_3145_298)",
    fillOpacity: 0.2
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 499.928V518.998H330.148V499.928C331.144 500.332 332.228 500.577 333.388 500.577C334.548 500.577 335.633 500.332 336.63 499.928Z",
    fill: "url(#paint304_radial_3145_298)",
    fillOpacity: 0.2
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 466.78H324.047C322.765 466.78 321.723 467.817 321.723 469.093V516.685C321.723 517.963 322.765 518.998 324.047 518.998H326.565V497.609C325.744 496.863 325.045 496.073 324.481 495.358C323.865 494.572 323.411 493.876 323.137 493.425C322.925 493.077 322.926 492.701 323.137 492.354C323.412 491.903 323.866 491.207 324.481 490.422C325.045 489.705 325.744 488.915 326.565 488.171V466.78Z",
    fill: "url(#paint305_radial_3145_298)",
    fillOpacity: 0.2
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M318.536 466.78V519C316.427 519 314.718 517.298 314.718 515.201V470.581C314.718 468.482 316.427 466.78 318.536 466.78Z",
    fill: "url(#paint306_radial_3145_298)",
    fillOpacity: 0.2
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M336.63 491.062C336.19 488.655 334.904 486.913 333.388 486.913C331.874 486.913 330.59 488.651 330.148 491.053C330.041 491.631 329.983 492.247 329.983 492.889C329.983 493.531 330.041 494.148 330.148 494.728C330.59 497.129 331.872 498.866 333.388 498.866C334.904 498.866 336.19 497.124 336.63 494.718C336.736 494.142 336.793 493.527 336.793 492.889C336.793 492.251 336.736 491.638 336.63 491.062Z",
    fill: "url(#paint307_radial_3145_298)",
    fillOpacity: 0.2
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M289.111 470.581V515.199C289.111 517.298 287.401 518.998 285.294 518.998V466.78C287.401 466.78 289.111 468.482 289.111 470.581Z",
    fill: "url(#paint308_radial_3145_298)",
    fillOpacity: 0.2
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M282.108 516.685V469.093C282.108 467.817 281.066 466.78 279.782 466.78H277.266V488.173C278.089 488.919 278.786 489.709 279.35 490.426C279.735 490.918 280.057 491.372 280.31 491.756C280.462 491.984 280.59 492.186 280.692 492.354C280.904 492.701 280.904 493.077 280.692 493.424C280.59 493.592 280.462 493.795 280.31 494.024C280.057 494.408 279.735 494.863 279.35 495.354C279.003 495.795 278.606 496.266 278.159 496.734C277.88 497.027 277.582 497.32 277.266 497.605V518.998H279.782C281.066 518.998 282.108 517.963 282.108 516.685Z",
    fill: "url(#paint309_radial_3145_298)",
    fillOpacity: 0.2
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M267.201 485.853V466.78H273.683V485.853C272.688 485.448 271.603 485.203 270.441 485.203C269.279 485.203 268.197 485.448 267.201 485.853Z",
    fill: "url(#paint310_radial_3145_298)",
    fillOpacity: 0.2
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 499.928V518.998H267.201V499.928C268.197 500.332 269.281 500.577 270.441 500.577C271.601 500.577 272.686 500.332 273.683 499.928Z",
    fill: "url(#paint311_radial_3145_298)",
    fillOpacity: 0.2
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M263.618 466.78H261.1C259.818 466.78 258.776 467.817 258.776 469.093V516.685C258.776 517.963 259.818 518.998 261.1 518.998H263.618V497.609C262.797 496.863 262.098 496.073 261.534 495.358C260.919 494.572 260.464 493.876 260.19 493.425C259.978 493.077 259.979 492.701 260.19 492.354C260.465 491.903 260.919 491.207 261.534 490.422C262.098 489.705 262.797 488.915 263.618 488.171V466.78Z",
    fill: "url(#paint312_radial_3145_298)",
    fillOpacity: 0.2
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M255.589 466.78V519C253.48 519 251.772 517.298 251.772 515.201V470.581C251.772 468.482 253.48 466.78 255.589 466.78Z",
    fill: "url(#paint313_radial_3145_298)",
    fillOpacity: 0.2
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 491.062C273.244 488.655 271.957 486.913 270.441 486.913C268.927 486.913 267.643 488.651 267.201 491.053C267.094 491.631 267.036 492.247 267.036 492.889C267.036 493.531 267.094 494.148 267.201 494.728C267.643 497.129 268.925 498.866 270.441 498.866C271.957 498.866 273.244 497.124 273.683 494.718C273.79 494.142 273.846 493.527 273.846 492.889C273.846 492.251 273.79 491.638 273.683 491.062Z",
    fill: "url(#paint314_radial_3145_298)",
    fillOpacity: 0.2
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 470.581V515.199C226.173 517.298 224.463 518.998 222.356 518.998V466.78C224.463 466.78 226.173 468.482 226.173 470.581Z",
    fill: "url(#paint315_radial_3145_298)",
    fillOpacity: 0.2
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 516.685V469.093C219.17 467.817 218.128 466.78 216.844 466.78H214.328V488.173C215.151 488.919 215.849 489.709 216.412 490.426C216.798 490.918 217.119 491.372 217.373 491.756C217.524 491.984 217.652 492.186 217.754 492.354C217.966 492.701 217.966 493.077 217.755 493.424C217.652 493.592 217.525 493.795 217.373 494.024C217.119 494.408 216.798 494.863 216.412 495.354C216.066 495.795 215.669 496.266 215.221 496.734C214.942 497.027 214.644 497.32 214.328 497.605V518.998H216.844C218.128 518.998 219.17 517.963 219.17 516.685Z",
    fill: "url(#paint316_radial_3145_298)",
    fillOpacity: 0.2
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M204.263 485.853V466.78H210.746V485.853C209.75 485.448 208.665 485.203 207.503 485.203C206.342 485.203 205.259 485.448 204.263 485.853Z",
    fill: "url(#paint317_radial_3145_298)",
    fillOpacity: 0.2
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 499.928V518.998H204.263V499.928C205.259 500.332 206.343 500.577 207.503 500.577C208.664 500.577 209.748 500.332 210.746 499.928Z",
    fill: "url(#paint318_radial_3145_298)",
    fillOpacity: 0.2
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 466.78H198.163C196.881 466.78 195.839 467.817 195.839 469.093V516.685C195.839 517.963 196.881 518.998 198.163 518.998H200.68V497.609C199.859 496.863 199.16 496.073 198.597 495.358C197.981 494.572 197.527 493.876 197.252 493.425C197.041 493.077 197.041 492.701 197.253 492.354C197.528 491.903 197.981 491.207 198.597 490.422C199.16 489.705 199.859 488.915 200.68 488.171V466.78Z",
    fill: "url(#paint319_radial_3145_298)",
    fillOpacity: 0.2
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M192.651 466.78V519C190.542 519 188.834 517.298 188.834 515.201V470.581C188.834 468.482 190.542 466.78 192.651 466.78Z",
    fill: "url(#paint320_radial_3145_298)",
    fillOpacity: 0.2
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 491.062C210.306 488.655 209.02 486.913 207.503 486.913C205.989 486.913 204.705 488.651 204.263 491.053C204.157 491.631 204.099 492.247 204.099 492.889C204.099 493.531 204.157 494.148 204.263 494.728C204.705 497.129 205.987 498.866 207.503 498.866C209.02 498.866 210.306 497.124 210.746 494.718C210.852 494.142 210.908 493.527 210.908 492.889C210.908 492.251 210.852 491.638 210.746 491.062Z",
    fill: "url(#paint321_radial_3145_298)",
    fillOpacity: 0.2
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 470.581V515.199C163.226 517.298 161.516 518.998 159.409 518.998V466.78C161.516 466.78 163.226 468.482 163.226 470.581Z",
    fill: "url(#paint322_radial_3145_298)",
    fillOpacity: 0.2
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M156.223 516.685V469.093C156.223 467.817 155.181 466.78 153.897 466.78H151.381V488.173C152.204 488.919 152.902 489.709 153.465 490.426C153.851 490.918 154.172 491.372 154.426 491.756C154.577 491.984 154.705 492.186 154.807 492.354C155.019 492.701 155.019 493.077 154.808 493.424C154.705 493.592 154.578 493.795 154.426 494.024C154.172 494.408 153.851 494.863 153.465 495.354C153.119 495.795 152.722 496.266 152.274 496.734C151.995 497.027 151.697 497.32 151.381 497.605V518.998H153.897C155.181 518.998 156.223 517.963 156.223 516.685Z",
    fill: "url(#paint323_radial_3145_298)",
    fillOpacity: 0.2
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 485.853V466.78H147.799V485.853C146.803 485.448 145.718 485.203 144.556 485.203C143.395 485.203 142.312 485.448 141.317 485.853Z",
    fill: "url(#paint324_radial_3145_298)",
    fillOpacity: 0.2
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 499.928V518.998H141.317V499.928C142.312 500.332 143.396 500.577 144.556 500.577C145.717 500.577 146.801 500.332 147.799 499.928Z",
    fill: "url(#paint325_radial_3145_298)",
    fillOpacity: 0.2
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M137.733 466.78H135.216C133.934 466.78 132.892 467.817 132.892 469.093V516.685C132.892 517.963 133.934 518.998 135.216 518.998H137.733V497.609C136.913 496.863 136.213 496.073 135.65 495.358C135.034 494.572 134.58 493.876 134.305 493.425C134.094 493.077 134.094 492.701 134.306 492.354C134.581 491.903 135.034 491.207 135.65 490.422C136.213 489.705 136.913 488.915 137.733 488.171V466.78Z",
    fill: "url(#paint326_radial_3145_298)",
    fillOpacity: 0.2
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M129.704 466.78V519C127.595 519 125.887 517.298 125.887 515.201V470.581C125.887 468.482 127.595 466.78 129.704 466.78Z",
    fill: "url(#paint327_radial_3145_298)",
    fillOpacity: 0.2
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M147.799 491.062C147.359 488.655 146.073 486.913 144.556 486.913C143.042 486.913 141.758 488.651 141.317 491.053C141.21 491.631 141.152 492.247 141.152 492.889C141.152 493.531 141.21 494.148 141.317 494.728C141.758 497.129 143.04 498.866 144.556 498.866C146.073 498.866 147.359 497.124 147.799 494.718C147.905 494.142 147.961 493.527 147.961 492.889C147.961 492.251 147.905 491.638 147.799 491.062Z",
    fill: "url(#paint328_radial_3145_298)",
    fillOpacity: 0.2
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M100.284 470.581V515.199C100.284 517.298 98.5738 518.998 96.4667 518.998V466.78C98.5738 466.78 100.284 468.482 100.284 470.581Z",
    fill: "url(#paint329_radial_3145_298)",
    fillOpacity: 0.2
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2806 516.685V469.093C93.2806 467.817 92.239 466.78 90.955 466.78H88.439V488.173C89.2621 488.919 89.9595 489.709 90.523 490.426C90.9084 490.918 91.2299 491.372 91.4834 491.756C91.6349 491.984 91.7626 492.186 91.8651 492.354C92.0767 492.701 92.077 493.077 91.8654 493.424C91.7629 493.592 91.6352 493.795 91.4834 494.024C91.2299 494.408 90.9084 494.863 90.523 495.354C90.1764 495.795 89.7794 496.266 89.332 496.734C89.0529 497.027 88.7549 497.32 88.439 497.605V518.998H90.955C92.239 518.998 93.2806 517.963 93.2806 516.685Z",
    fill: "url(#paint330_radial_3145_298)",
    fillOpacity: 0.2
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3743 485.853V466.78H84.8563V485.853C83.8608 485.448 82.7762 485.203 81.6142 485.203C80.4522 485.203 79.3697 485.448 78.3743 485.853Z",
    fill: "url(#paint331_radial_3145_298)",
    fillOpacity: 0.2
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 499.928V518.998H78.3743V499.928C79.3697 500.332 80.454 500.577 81.6142 500.577C82.7744 500.577 83.8587 500.332 84.8563 499.928Z",
    fill: "url(#paint332_radial_3145_298)",
    fillOpacity: 0.2
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7912 466.78H72.2735C70.9915 466.78 69.9496 467.817 69.9496 469.093V516.685C69.9496 517.963 70.9915 518.998 72.2735 518.998H74.7912V497.609C73.9702 496.863 73.271 496.073 72.7075 495.358C72.0916 494.572 71.6376 493.876 71.3626 493.425C71.1514 493.077 71.1517 492.701 71.3634 492.354C71.6383 491.903 72.0919 491.207 72.7075 490.422C73.271 489.705 73.9702 488.915 74.7912 488.171V466.78Z",
    fill: "url(#paint333_radial_3145_298)",
    fillOpacity: 0.2
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7617 466.78V519C64.6529 519 62.9446 517.298 62.9446 515.201V470.581C62.9446 468.482 64.6529 466.78 66.7617 466.78Z",
    fill: "url(#paint334_radial_3145_298)",
    fillOpacity: 0.2
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8563 491.062C84.4166 488.655 83.1305 486.913 81.6142 486.913C80.0997 486.913 78.8157 488.651 78.3743 491.053C78.2676 491.631 78.2095 492.247 78.2095 492.889C78.2095 493.531 78.2676 494.148 78.3743 494.728C78.8157 497.129 80.0979 498.866 81.6142 498.866C83.1305 498.866 84.4166 497.124 84.8563 494.718C84.9626 494.142 85.019 493.527 85.019 492.889C85.019 492.251 84.9626 491.638 84.8563 491.062Z",
    fill: "url(#paint335_radial_3145_298)",
    fillOpacity: 0.2
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3392 470.581V515.199C37.3392 517.298 35.6291 518.998 33.5221 518.998V466.78C35.6291 466.78 37.3392 468.482 37.3392 470.581Z",
    fill: "url(#paint336_radial_3145_298)",
    fillOpacity: 0.2
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 516.685V469.093C30.336 467.817 29.2943 466.78 28.0103 466.78H25.4944V488.173C26.3174 488.919 27.0149 489.709 27.5784 490.426C27.9638 490.918 28.2852 491.372 28.5388 491.756C28.6902 491.984 28.8179 492.186 28.9204 492.354C29.132 492.701 29.1324 493.077 28.9208 493.424C28.8183 493.592 28.6906 493.795 28.5388 494.024C28.2852 494.408 27.9638 494.863 27.5784 495.354C27.2318 495.795 26.8347 496.266 26.3874 496.734C26.1082 497.027 25.8102 497.32 25.4944 497.605V518.998H28.0103C29.2943 518.998 30.336 517.963 30.336 516.685Z",
    fill: "url(#paint337_radial_3145_298)",
    fillOpacity: 0.2
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4296 485.853V466.78H21.9116V485.853C20.9162 485.448 19.8315 485.203 18.6696 485.203C17.5076 485.203 16.4251 485.448 15.4296 485.853Z",
    fill: "url(#paint338_radial_3145_298)",
    fillOpacity: 0.2
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 499.928V518.998H15.4296V499.928C16.4251 500.332 17.5094 500.577 18.6696 500.577C19.8298 500.577 20.9141 500.332 21.9116 499.928Z",
    fill: "url(#paint339_radial_3145_298)",
    fillOpacity: 0.2
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8465 466.78H9.32883C8.04691 466.78 7.00491 467.817 7.00491 469.093V516.685C7.00491 517.963 8.04691 518.998 9.32883 518.998H11.8465V497.609C11.0256 496.863 10.3264 496.073 9.76291 495.358C9.14694 494.572 8.6929 493.876 8.418 493.425C8.20673 493.077 8.20712 492.701 8.41873 492.354C8.69366 491.903 9.14731 491.207 9.76291 490.422C10.3264 489.705 11.0256 488.915 11.8465 488.171V466.78Z",
    fill: "url(#paint340_radial_3145_298)",
    fillOpacity: 0.2
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81711 466.78V519C1.70831 519 0 517.298 0 515.201V470.581C0 468.482 1.70831 466.78 3.81711 466.78Z",
    fill: "url(#paint341_radial_3145_298)",
    fillOpacity: 0.2
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9116 491.062C21.472 488.655 20.1859 486.913 18.6696 486.913C17.155 486.913 15.871 488.651 15.4296 491.053C15.3229 491.631 15.2649 492.247 15.2649 492.889C15.2649 493.531 15.3229 494.148 15.4296 494.728C15.871 497.129 17.1533 498.866 18.6696 498.866C20.1859 498.866 21.472 497.124 21.9116 494.718C22.0179 494.142 22.0743 493.527 22.0743 492.889C22.0743 492.251 22.0179 491.638 21.9116 491.062Z",
    fill: "url(#paint342_radial_3145_298)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint317_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint334_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint337_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint338_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint340_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint341_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint342_radial_3145_298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 260) rotate(90) scale(259 207.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893505
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayBg);
export default __webpack_public_path__ + "static/media/how-to-play-bg.bd35279fe1e7be826f163af64b12ab4f.svg";
export { ForwardRef as ReactComponent };